// --- BEGIN AUTO-GENERATED FILE ---
//
// @IconsVersion: 1.2.2
// @Generated: 2021-01-01T00:29:10.157Z
//
// This file is generated on each build. Do not edit this file!

import { pluginFactoryNoConfig } from '../utils/plugins'

// Icon helper component
import { BIcon } from './icon'

// Icon stacking component
import { BIconstack } from './iconstack'

import {
  // BootstrapVue custom icons
  BIconBlank,
  // Bootstrap icons
  BIconAlarm,
  BIconAlarmFill,
  BIconAlignBottom,
  BIconAlignCenter,
  BIconAlignEnd,
  BIconAlignMiddle,
  BIconAlignStart,
  BIconAlignTop,
  BIconAlt,
  BIconApp,
  BIconAppIndicator,
  BIconArchive,
  BIconArchiveFill,
  BIconArrow90degDown,
  BIconArrow90degLeft,
  BIconArrow90degRight,
  BIconArrow90degUp,
  BIconArrowBarDown,
  BIconArrowBarLeft,
  BIconArrowBarRight,
  BIconArrowBarUp,
  BIconArrowClockwise,
  BIconArrowCounterclockwise,
  BIconArrowDown,
  BIconArrowDownCircle,
  BIconArrowDownCircleFill,
  BIconArrowDownLeft,
  BIconArrowDownLeftCircle,
  BIconArrowDownLeftCircleFill,
  BIconArrowDownLeftSquare,
  BIconArrowDownLeftSquareFill,
  BIconArrowDownRight,
  BIconArrowDownRightCircle,
  BIconArrowDownRightCircleFill,
  BIconArrowDownRightSquare,
  BIconArrowDownRightSquareFill,
  BIconArrowDownShort,
  BIconArrowDownSquare,
  BIconArrowDownSquareFill,
  BIconArrowDownUp,
  BIconArrowLeft,
  BIconArrowLeftCircle,
  BIconArrowLeftCircleFill,
  BIconArrowLeftRight,
  BIconArrowLeftShort,
  BIconArrowLeftSquare,
  BIconArrowLeftSquareFill,
  BIconArrowRepeat,
  BIconArrowReturnLeft,
  BIconArrowReturnRight,
  BIconArrowRight,
  BIconArrowRightCircle,
  BIconArrowRightCircleFill,
  BIconArrowRightShort,
  BIconArrowRightSquare,
  BIconArrowRightSquareFill,
  BIconArrowUp,
  BIconArrowUpCircle,
  BIconArrowUpCircleFill,
  BIconArrowUpLeft,
  BIconArrowUpLeftCircle,
  BIconArrowUpLeftCircleFill,
  BIconArrowUpLeftSquare,
  BIconArrowUpLeftSquareFill,
  BIconArrowUpRight,
  BIconArrowUpRightCircle,
  BIconArrowUpRightCircleFill,
  BIconArrowUpRightSquare,
  BIconArrowUpRightSquareFill,
  BIconArrowUpShort,
  BIconArrowUpSquare,
  BIconArrowUpSquareFill,
  BIconArrowsAngleContract,
  BIconArrowsAngleExpand,
  BIconArrowsCollapse,
  BIconArrowsExpand,
  BIconArrowsFullscreen,
  BIconArrowsMove,
  BIconAspectRatio,
  BIconAspectRatioFill,
  BIconAsterisk,
  BIconAt,
  BIconAward,
  BIconAwardFill,
  BIconBack,
  BIconBackspace,
  BIconBackspaceFill,
  BIconBackspaceReverse,
  BIconBackspaceReverseFill,
  BIconBadge4k,
  BIconBadge4kFill,
  BIconBadge8k,
  BIconBadge8kFill,
  BIconBadgeAd,
  BIconBadgeAdFill,
  BIconBadgeCc,
  BIconBadgeCcFill,
  BIconBadgeHd,
  BIconBadgeHdFill,
  BIconBadgeTm,
  BIconBadgeTmFill,
  BIconBadgeVo,
  BIconBadgeVoFill,
  BIconBag,
  BIconBagCheck,
  BIconBagCheckFill,
  BIconBagDash,
  BIconBagDashFill,
  BIconBagFill,
  BIconBagPlus,
  BIconBagPlusFill,
  BIconBagX,
  BIconBagXFill,
  BIconBarChart,
  BIconBarChartFill,
  BIconBarChartLine,
  BIconBarChartLineFill,
  BIconBarChartSteps,
  BIconBasket,
  BIconBasket2,
  BIconBasket2Fill,
  BIconBasket3,
  BIconBasket3Fill,
  BIconBasketFill,
  BIconBattery,
  BIconBatteryCharging,
  BIconBatteryFull,
  BIconBatteryHalf,
  BIconBell,
  BIconBellFill,
  BIconBezier,
  BIconBezier2,
  BIconBicycle,
  BIconBinoculars,
  BIconBinocularsFill,
  BIconBlockquoteLeft,
  BIconBlockquoteRight,
  BIconBook,
  BIconBookFill,
  BIconBookHalf,
  BIconBookmark,
  BIconBookmarkCheck,
  BIconBookmarkCheckFill,
  BIconBookmarkDash,
  BIconBookmarkDashFill,
  BIconBookmarkFill,
  BIconBookmarkHeart,
  BIconBookmarkHeartFill,
  BIconBookmarkPlus,
  BIconBookmarkPlusFill,
  BIconBookmarkStar,
  BIconBookmarkStarFill,
  BIconBookmarkX,
  BIconBookmarkXFill,
  BIconBookmarks,
  BIconBookmarksFill,
  BIconBookshelf,
  BIconBootstrap,
  BIconBootstrapFill,
  BIconBootstrapReboot,
  BIconBorderStyle,
  BIconBorderWidth,
  BIconBoundingBox,
  BIconBoundingBoxCircles,
  BIconBox,
  BIconBoxArrowDown,
  BIconBoxArrowDownLeft,
  BIconBoxArrowDownRight,
  BIconBoxArrowInDown,
  BIconBoxArrowInDownLeft,
  BIconBoxArrowInDownRight,
  BIconBoxArrowInLeft,
  BIconBoxArrowInRight,
  BIconBoxArrowInUp,
  BIconBoxArrowInUpLeft,
  BIconBoxArrowInUpRight,
  BIconBoxArrowLeft,
  BIconBoxArrowRight,
  BIconBoxArrowUp,
  BIconBoxArrowUpLeft,
  BIconBoxArrowUpRight,
  BIconBoxSeam,
  BIconBraces,
  BIconBricks,
  BIconBriefcase,
  BIconBriefcaseFill,
  BIconBrightnessAltHigh,
  BIconBrightnessAltHighFill,
  BIconBrightnessAltLow,
  BIconBrightnessAltLowFill,
  BIconBrightnessHigh,
  BIconBrightnessHighFill,
  BIconBrightnessLow,
  BIconBrightnessLowFill,
  BIconBroadcast,
  BIconBroadcastPin,
  BIconBrush,
  BIconBrushFill,
  BIconBucket,
  BIconBucketFill,
  BIconBug,
  BIconBugFill,
  BIconBuilding,
  BIconBullseye,
  BIconCalculator,
  BIconCalculatorFill,
  BIconCalendar,
  BIconCalendar2,
  BIconCalendar2Check,
  BIconCalendar2CheckFill,
  BIconCalendar2Date,
  BIconCalendar2DateFill,
  BIconCalendar2Day,
  BIconCalendar2DayFill,
  BIconCalendar2Event,
  BIconCalendar2EventFill,
  BIconCalendar2Fill,
  BIconCalendar2Minus,
  BIconCalendar2MinusFill,
  BIconCalendar2Month,
  BIconCalendar2MonthFill,
  BIconCalendar2Plus,
  BIconCalendar2PlusFill,
  BIconCalendar2Range,
  BIconCalendar2RangeFill,
  BIconCalendar2Week,
  BIconCalendar2WeekFill,
  BIconCalendar2X,
  BIconCalendar2XFill,
  BIconCalendar3,
  BIconCalendar3Event,
  BIconCalendar3EventFill,
  BIconCalendar3Fill,
  BIconCalendar3Range,
  BIconCalendar3RangeFill,
  BIconCalendar3Week,
  BIconCalendar3WeekFill,
  BIconCalendar4,
  BIconCalendar4Event,
  BIconCalendar4Range,
  BIconCalendar4Week,
  BIconCalendarCheck,
  BIconCalendarCheckFill,
  BIconCalendarDate,
  BIconCalendarDateFill,
  BIconCalendarDay,
  BIconCalendarDayFill,
  BIconCalendarEvent,
  BIconCalendarEventFill,
  BIconCalendarFill,
  BIconCalendarMinus,
  BIconCalendarMinusFill,
  BIconCalendarMonth,
  BIconCalendarMonthFill,
  BIconCalendarPlus,
  BIconCalendarPlusFill,
  BIconCalendarRange,
  BIconCalendarRangeFill,
  BIconCalendarWeek,
  BIconCalendarWeekFill,
  BIconCalendarX,
  BIconCalendarXFill,
  BIconCamera,
  BIconCamera2,
  BIconCameraFill,
  BIconCameraReels,
  BIconCameraReelsFill,
  BIconCameraVideo,
  BIconCameraVideoFill,
  BIconCameraVideoOff,
  BIconCameraVideoOffFill,
  BIconCapslock,
  BIconCapslockFill,
  BIconCardChecklist,
  BIconCardHeading,
  BIconCardImage,
  BIconCardList,
  BIconCardText,
  BIconCaretDown,
  BIconCaretDownFill,
  BIconCaretDownSquare,
  BIconCaretDownSquareFill,
  BIconCaretLeft,
  BIconCaretLeftFill,
  BIconCaretLeftSquare,
  BIconCaretLeftSquareFill,
  BIconCaretRight,
  BIconCaretRightFill,
  BIconCaretRightSquare,
  BIconCaretRightSquareFill,
  BIconCaretUp,
  BIconCaretUpFill,
  BIconCaretUpSquare,
  BIconCaretUpSquareFill,
  BIconCart,
  BIconCart2,
  BIconCart3,
  BIconCart4,
  BIconCartCheck,
  BIconCartCheckFill,
  BIconCartDash,
  BIconCartDashFill,
  BIconCartFill,
  BIconCartPlus,
  BIconCartPlusFill,
  BIconCartX,
  BIconCartXFill,
  BIconCash,
  BIconCashStack,
  BIconCast,
  BIconChat,
  BIconChatDots,
  BIconChatDotsFill,
  BIconChatFill,
  BIconChatLeft,
  BIconChatLeftDots,
  BIconChatLeftDotsFill,
  BIconChatLeftFill,
  BIconChatLeftQuote,
  BIconChatLeftQuoteFill,
  BIconChatLeftText,
  BIconChatLeftTextFill,
  BIconChatQuote,
  BIconChatQuoteFill,
  BIconChatRight,
  BIconChatRightDots,
  BIconChatRightDotsFill,
  BIconChatRightFill,
  BIconChatRightQuote,
  BIconChatRightQuoteFill,
  BIconChatRightText,
  BIconChatRightTextFill,
  BIconChatSquare,
  BIconChatSquareDots,
  BIconChatSquareDotsFill,
  BIconChatSquareFill,
  BIconChatSquareQuote,
  BIconChatSquareQuoteFill,
  BIconChatSquareText,
  BIconChatSquareTextFill,
  BIconChatText,
  BIconChatTextFill,
  BIconCheck,
  BIconCheck2,
  BIconCheck2All,
  BIconCheck2Circle,
  BIconCheck2Square,
  BIconCheckAll,
  BIconCheckCircle,
  BIconCheckCircleFill,
  BIconCheckSquare,
  BIconCheckSquareFill,
  BIconChevronBarContract,
  BIconChevronBarDown,
  BIconChevronBarExpand,
  BIconChevronBarLeft,
  BIconChevronBarRight,
  BIconChevronBarUp,
  BIconChevronCompactDown,
  BIconChevronCompactLeft,
  BIconChevronCompactRight,
  BIconChevronCompactUp,
  BIconChevronContract,
  BIconChevronDoubleDown,
  BIconChevronDoubleLeft,
  BIconChevronDoubleRight,
  BIconChevronDoubleUp,
  BIconChevronDown,
  BIconChevronExpand,
  BIconChevronLeft,
  BIconChevronRight,
  BIconChevronUp,
  BIconCircle,
  BIconCircleFill,
  BIconCircleHalf,
  BIconCircleSquare,
  BIconClipboard,
  BIconClipboardCheck,
  BIconClipboardData,
  BIconClipboardMinus,
  BIconClipboardPlus,
  BIconClipboardX,
  BIconClock,
  BIconClockFill,
  BIconClockHistory,
  BIconCloud,
  BIconCloudArrowDown,
  BIconCloudArrowDownFill,
  BIconCloudArrowUp,
  BIconCloudArrowUpFill,
  BIconCloudCheck,
  BIconCloudCheckFill,
  BIconCloudDownload,
  BIconCloudDownloadFill,
  BIconCloudFill,
  BIconCloudMinus,
  BIconCloudMinusFill,
  BIconCloudPlus,
  BIconCloudPlusFill,
  BIconCloudSlash,
  BIconCloudSlashFill,
  BIconCloudUpload,
  BIconCloudUploadFill,
  BIconCode,
  BIconCodeSlash,
  BIconCodeSquare,
  BIconCollection,
  BIconCollectionFill,
  BIconCollectionPlay,
  BIconCollectionPlayFill,
  BIconColumns,
  BIconColumnsGap,
  BIconCommand,
  BIconCompass,
  BIconCompassFill,
  BIconCone,
  BIconConeStriped,
  BIconController,
  BIconCpu,
  BIconCpuFill,
  BIconCreditCard,
  BIconCreditCard2Back,
  BIconCreditCard2BackFill,
  BIconCreditCard2Front,
  BIconCreditCard2FrontFill,
  BIconCreditCardFill,
  BIconCrop,
  BIconCup,
  BIconCupFill,
  BIconCupStraw,
  BIconCursor,
  BIconCursorFill,
  BIconCursorText,
  BIconDash,
  BIconDashCircle,
  BIconDashCircleFill,
  BIconDashSquare,
  BIconDashSquareFill,
  BIconDiagram2,
  BIconDiagram2Fill,
  BIconDiagram3,
  BIconDiagram3Fill,
  BIconDiamond,
  BIconDiamondFill,
  BIconDiamondHalf,
  BIconDice1,
  BIconDice1Fill,
  BIconDice2,
  BIconDice2Fill,
  BIconDice3,
  BIconDice3Fill,
  BIconDice4,
  BIconDice4Fill,
  BIconDice5,
  BIconDice5Fill,
  BIconDice6,
  BIconDice6Fill,
  BIconDisc,
  BIconDiscFill,
  BIconDiscord,
  BIconDisplay,
  BIconDisplayFill,
  BIconDistributeHorizontal,
  BIconDistributeVertical,
  BIconDoorClosed,
  BIconDoorClosedFill,
  BIconDoorOpen,
  BIconDoorOpenFill,
  BIconDot,
  BIconDownload,
  BIconDroplet,
  BIconDropletFill,
  BIconDropletHalf,
  BIconEarbuds,
  BIconEasel,
  BIconEaselFill,
  BIconEgg,
  BIconEggFill,
  BIconEggFried,
  BIconEject,
  BIconEjectFill,
  BIconEmojiAngry,
  BIconEmojiAngryFill,
  BIconEmojiDizzy,
  BIconEmojiDizzyFill,
  BIconEmojiExpressionless,
  BIconEmojiExpressionlessFill,
  BIconEmojiFrown,
  BIconEmojiFrownFill,
  BIconEmojiHeartEyes,
  BIconEmojiHeartEyesFill,
  BIconEmojiLaughing,
  BIconEmojiLaughingFill,
  BIconEmojiNeutral,
  BIconEmojiNeutralFill,
  BIconEmojiSmile,
  BIconEmojiSmileFill,
  BIconEmojiSmileUpsideDown,
  BIconEmojiSmileUpsideDownFill,
  BIconEmojiSunglasses,
  BIconEmojiSunglassesFill,
  BIconEmojiWink,
  BIconEmojiWinkFill,
  BIconEnvelope,
  BIconEnvelopeFill,
  BIconEnvelopeOpen,
  BIconEnvelopeOpenFill,
  BIconExclamation,
  BIconExclamationCircle,
  BIconExclamationCircleFill,
  BIconExclamationDiamond,
  BIconExclamationDiamondFill,
  BIconExclamationOctagon,
  BIconExclamationOctagonFill,
  BIconExclamationSquare,
  BIconExclamationSquareFill,
  BIconExclamationTriangle,
  BIconExclamationTriangleFill,
  BIconExclude,
  BIconEye,
  BIconEyeFill,
  BIconEyeSlash,
  BIconEyeSlashFill,
  BIconEyeglasses,
  BIconFacebook,
  BIconFile,
  BIconFileArrowDown,
  BIconFileArrowDownFill,
  BIconFileArrowUp,
  BIconFileArrowUpFill,
  BIconFileBarGraph,
  BIconFileBarGraphFill,
  BIconFileBinary,
  BIconFileBinaryFill,
  BIconFileBreak,
  BIconFileBreakFill,
  BIconFileCheck,
  BIconFileCheckFill,
  BIconFileCode,
  BIconFileCodeFill,
  BIconFileDiff,
  BIconFileDiffFill,
  BIconFileEarmark,
  BIconFileEarmarkArrowDown,
  BIconFileEarmarkArrowDownFill,
  BIconFileEarmarkArrowUp,
  BIconFileEarmarkArrowUpFill,
  BIconFileEarmarkBarGraph,
  BIconFileEarmarkBarGraphFill,
  BIconFileEarmarkBinary,
  BIconFileEarmarkBinaryFill,
  BIconFileEarmarkBreak,
  BIconFileEarmarkBreakFill,
  BIconFileEarmarkCheck,
  BIconFileEarmarkCheckFill,
  BIconFileEarmarkCode,
  BIconFileEarmarkCodeFill,
  BIconFileEarmarkDiff,
  BIconFileEarmarkDiffFill,
  BIconFileEarmarkEasel,
  BIconFileEarmarkEaselFill,
  BIconFileEarmarkExcel,
  BIconFileEarmarkExcelFill,
  BIconFileEarmarkFill,
  BIconFileEarmarkFont,
  BIconFileEarmarkFontFill,
  BIconFileEarmarkImage,
  BIconFileEarmarkImageFill,
  BIconFileEarmarkLock,
  BIconFileEarmarkLock2,
  BIconFileEarmarkLock2Fill,
  BIconFileEarmarkLockFill,
  BIconFileEarmarkMedical,
  BIconFileEarmarkMedicalFill,
  BIconFileEarmarkMinus,
  BIconFileEarmarkMinusFill,
  BIconFileEarmarkMusic,
  BIconFileEarmarkMusicFill,
  BIconFileEarmarkPerson,
  BIconFileEarmarkPersonFill,
  BIconFileEarmarkPlay,
  BIconFileEarmarkPlayFill,
  BIconFileEarmarkPlus,
  BIconFileEarmarkPlusFill,
  BIconFileEarmarkPost,
  BIconFileEarmarkPostFill,
  BIconFileEarmarkPpt,
  BIconFileEarmarkPptFill,
  BIconFileEarmarkRichtext,
  BIconFileEarmarkRichtextFill,
  BIconFileEarmarkRuled,
  BIconFileEarmarkRuledFill,
  BIconFileEarmarkSlides,
  BIconFileEarmarkSlidesFill,
  BIconFileEarmarkSpreadsheet,
  BIconFileEarmarkSpreadsheetFill,
  BIconFileEarmarkText,
  BIconFileEarmarkTextFill,
  BIconFileEarmarkWord,
  BIconFileEarmarkWordFill,
  BIconFileEarmarkX,
  BIconFileEarmarkXFill,
  BIconFileEarmarkZip,
  BIconFileEarmarkZipFill,
  BIconFileEasel,
  BIconFileEaselFill,
  BIconFileExcel,
  BIconFileExcelFill,
  BIconFileFill,
  BIconFileFont,
  BIconFileFontFill,
  BIconFileImage,
  BIconFileImageFill,
  BIconFileLock,
  BIconFileLock2,
  BIconFileLock2Fill,
  BIconFileLockFill,
  BIconFileMedical,
  BIconFileMedicalFill,
  BIconFileMinus,
  BIconFileMinusFill,
  BIconFileMusic,
  BIconFileMusicFill,
  BIconFilePerson,
  BIconFilePersonFill,
  BIconFilePlay,
  BIconFilePlayFill,
  BIconFilePlus,
  BIconFilePlusFill,
  BIconFilePost,
  BIconFilePostFill,
  BIconFilePpt,
  BIconFilePptFill,
  BIconFileRichtext,
  BIconFileRichtextFill,
  BIconFileRuled,
  BIconFileRuledFill,
  BIconFileSlides,
  BIconFileSlidesFill,
  BIconFileSpreadsheet,
  BIconFileSpreadsheetFill,
  BIconFileText,
  BIconFileTextFill,
  BIconFileWord,
  BIconFileWordFill,
  BIconFileX,
  BIconFileXFill,
  BIconFileZip,
  BIconFileZipFill,
  BIconFiles,
  BIconFilesAlt,
  BIconFilm,
  BIconFilter,
  BIconFilterCircle,
  BIconFilterCircleFill,
  BIconFilterLeft,
  BIconFilterRight,
  BIconFilterSquare,
  BIconFilterSquareFill,
  BIconFlag,
  BIconFlagFill,
  BIconFlower1,
  BIconFlower2,
  BIconFlower3,
  BIconFolder,
  BIconFolder2,
  BIconFolder2Open,
  BIconFolderCheck,
  BIconFolderFill,
  BIconFolderMinus,
  BIconFolderPlus,
  BIconFolderSymlink,
  BIconFolderSymlinkFill,
  BIconFolderX,
  BIconFonts,
  BIconForward,
  BIconForwardFill,
  BIconFront,
  BIconFullscreen,
  BIconFullscreenExit,
  BIconFunnel,
  BIconFunnelFill,
  BIconGear,
  BIconGearFill,
  BIconGearWide,
  BIconGearWideConnected,
  BIconGem,
  BIconGeo,
  BIconGeoAlt,
  BIconGeoAltFill,
  BIconGeoFill,
  BIconGift,
  BIconGiftFill,
  BIconGithub,
  BIconGlobe,
  BIconGlobe2,
  BIconGoogle,
  BIconGraphDown,
  BIconGraphUp,
  BIconGrid,
  BIconGrid1x2,
  BIconGrid1x2Fill,
  BIconGrid3x2,
  BIconGrid3x2Gap,
  BIconGrid3x2GapFill,
  BIconGrid3x3,
  BIconGrid3x3Gap,
  BIconGrid3x3GapFill,
  BIconGridFill,
  BIconGripHorizontal,
  BIconGripVertical,
  BIconHammer,
  BIconHandIndex,
  BIconHandIndexThumb,
  BIconHandThumbsDown,
  BIconHandThumbsUp,
  BIconHandbag,
  BIconHandbagFill,
  BIconHash,
  BIconHdd,
  BIconHddFill,
  BIconHddNetwork,
  BIconHddNetworkFill,
  BIconHddRack,
  BIconHddRackFill,
  BIconHddStack,
  BIconHddStackFill,
  BIconHeadphones,
  BIconHeadset,
  BIconHeart,
  BIconHeartFill,
  BIconHeartHalf,
  BIconHeptagon,
  BIconHeptagonFill,
  BIconHeptagonHalf,
  BIconHexagon,
  BIconHexagonFill,
  BIconHexagonHalf,
  BIconHourglass,
  BIconHourglassBottom,
  BIconHourglassSplit,
  BIconHourglassTop,
  BIconHouse,
  BIconHouseDoor,
  BIconHouseDoorFill,
  BIconHouseFill,
  BIconHr,
  BIconImage,
  BIconImageAlt,
  BIconImageFill,
  BIconImages,
  BIconInbox,
  BIconInboxFill,
  BIconInboxes,
  BIconInboxesFill,
  BIconInfo,
  BIconInfoCircle,
  BIconInfoCircleFill,
  BIconInfoSquare,
  BIconInfoSquareFill,
  BIconInputCursor,
  BIconInputCursorText,
  BIconInstagram,
  BIconIntersect,
  BIconJournal,
  BIconJournalAlbum,
  BIconJournalArrowDown,
  BIconJournalArrowUp,
  BIconJournalBookmark,
  BIconJournalBookmarkFill,
  BIconJournalCheck,
  BIconJournalCode,
  BIconJournalMedical,
  BIconJournalMinus,
  BIconJournalPlus,
  BIconJournalRichtext,
  BIconJournalText,
  BIconJournalX,
  BIconJournals,
  BIconJoystick,
  BIconJustify,
  BIconJustifyLeft,
  BIconJustifyRight,
  BIconKanban,
  BIconKanbanFill,
  BIconKey,
  BIconKeyFill,
  BIconKeyboard,
  BIconKeyboardFill,
  BIconLadder,
  BIconLamp,
  BIconLampFill,
  BIconLaptop,
  BIconLaptopFill,
  BIconLayers,
  BIconLayersFill,
  BIconLayersHalf,
  BIconLayoutSidebar,
  BIconLayoutSidebarInset,
  BIconLayoutSidebarInsetReverse,
  BIconLayoutSidebarReverse,
  BIconLayoutSplit,
  BIconLayoutTextSidebar,
  BIconLayoutTextSidebarReverse,
  BIconLayoutTextWindow,
  BIconLayoutTextWindowReverse,
  BIconLayoutThreeColumns,
  BIconLayoutWtf,
  BIconLifePreserver,
  BIconLightning,
  BIconLightningFill,
  BIconLink,
  BIconLink45deg,
  BIconLinkedin,
  BIconList,
  BIconListCheck,
  BIconListNested,
  BIconListOl,
  BIconListStars,
  BIconListTask,
  BIconListUl,
  BIconLock,
  BIconLockFill,
  BIconMailbox,
  BIconMailbox2,
  BIconMap,
  BIconMapFill,
  BIconMarkdown,
  BIconMarkdownFill,
  BIconMenuApp,
  BIconMenuAppFill,
  BIconMenuButton,
  BIconMenuButtonFill,
  BIconMenuButtonWide,
  BIconMenuButtonWideFill,
  BIconMenuDown,
  BIconMenuUp,
  BIconMic,
  BIconMicFill,
  BIconMicMute,
  BIconMicMuteFill,
  BIconMinecart,
  BIconMinecartLoaded,
  BIconMoon,
  BIconMouse,
  BIconMouse2,
  BIconMouse3,
  BIconMusicNote,
  BIconMusicNoteBeamed,
  BIconMusicNoteList,
  BIconMusicPlayer,
  BIconMusicPlayerFill,
  BIconNewspaper,
  BIconNodeMinus,
  BIconNodeMinusFill,
  BIconNodePlus,
  BIconNodePlusFill,
  BIconNut,
  BIconNutFill,
  BIconOctagon,
  BIconOctagonFill,
  BIconOctagonHalf,
  BIconOption,
  BIconOutlet,
  BIconPaperclip,
  BIconParagraph,
  BIconPatchCheck,
  BIconPatchCheckFill,
  BIconPatchExclamation,
  BIconPatchExclamationFill,
  BIconPatchMinus,
  BIconPatchMinusFill,
  BIconPatchPlus,
  BIconPatchPlusFill,
  BIconPatchQuestion,
  BIconPatchQuestionFill,
  BIconPause,
  BIconPauseBtn,
  BIconPauseBtnFill,
  BIconPauseCircle,
  BIconPauseCircleFill,
  BIconPauseFill,
  BIconPeace,
  BIconPeaceFill,
  BIconPen,
  BIconPenFill,
  BIconPencil,
  BIconPencilFill,
  BIconPencilSquare,
  BIconPentagon,
  BIconPentagonFill,
  BIconPentagonHalf,
  BIconPeople,
  BIconPeopleFill,
  BIconPercent,
  BIconPerson,
  BIconPersonBadge,
  BIconPersonBadgeFill,
  BIconPersonBoundingBox,
  BIconPersonCheck,
  BIconPersonCheckFill,
  BIconPersonCircle,
  BIconPersonDash,
  BIconPersonDashFill,
  BIconPersonFill,
  BIconPersonLinesFill,
  BIconPersonPlus,
  BIconPersonPlusFill,
  BIconPersonSquare,
  BIconPersonX,
  BIconPersonXFill,
  BIconPhone,
  BIconPhoneFill,
  BIconPhoneLandscape,
  BIconPhoneLandscapeFill,
  BIconPhoneVibrate,
  BIconPieChart,
  BIconPieChartFill,
  BIconPip,
  BIconPipFill,
  BIconPlay,
  BIconPlayBtn,
  BIconPlayBtnFill,
  BIconPlayCircle,
  BIconPlayCircleFill,
  BIconPlayFill,
  BIconPlug,
  BIconPlugFill,
  BIconPlus,
  BIconPlusCircle,
  BIconPlusCircleFill,
  BIconPlusSquare,
  BIconPlusSquareFill,
  BIconPower,
  BIconPrinter,
  BIconPrinterFill,
  BIconPuzzle,
  BIconPuzzleFill,
  BIconQuestion,
  BIconQuestionCircle,
  BIconQuestionCircleFill,
  BIconQuestionDiamond,
  BIconQuestionDiamondFill,
  BIconQuestionOctagon,
  BIconQuestionOctagonFill,
  BIconQuestionSquare,
  BIconQuestionSquareFill,
  BIconReceipt,
  BIconReceiptCutoff,
  BIconReception0,
  BIconReception1,
  BIconReception2,
  BIconReception3,
  BIconReception4,
  BIconRecord,
  BIconRecord2,
  BIconRecord2Fill,
  BIconRecordBtn,
  BIconRecordBtnFill,
  BIconRecordCircle,
  BIconRecordCircleFill,
  BIconRecordFill,
  BIconReply,
  BIconReplyAll,
  BIconReplyAllFill,
  BIconReplyFill,
  BIconRss,
  BIconRssFill,
  BIconScissors,
  BIconScrewdriver,
  BIconSearch,
  BIconSegmentedNav,
  BIconServer,
  BIconShare,
  BIconShareFill,
  BIconShield,
  BIconShieldCheck,
  BIconShieldExclamation,
  BIconShieldFill,
  BIconShieldFillCheck,
  BIconShieldFillExclamation,
  BIconShieldFillMinus,
  BIconShieldFillPlus,
  BIconShieldFillX,
  BIconShieldLock,
  BIconShieldLockFill,
  BIconShieldMinus,
  BIconShieldPlus,
  BIconShieldShaded,
  BIconShieldSlash,
  BIconShieldSlashFill,
  BIconShieldX,
  BIconShift,
  BIconShiftFill,
  BIconShop,
  BIconShopWindow,
  BIconShuffle,
  BIconSignpost,
  BIconSignpost2,
  BIconSignpost2Fill,
  BIconSignpostFill,
  BIconSignpostSplit,
  BIconSignpostSplitFill,
  BIconSim,
  BIconSimFill,
  BIconSkipBackward,
  BIconSkipBackwardBtn,
  BIconSkipBackwardBtnFill,
  BIconSkipBackwardCircle,
  BIconSkipBackwardCircleFill,
  BIconSkipBackwardFill,
  BIconSkipEnd,
  BIconSkipEndBtn,
  BIconSkipEndBtnFill,
  BIconSkipEndCircle,
  BIconSkipEndCircleFill,
  BIconSkipEndFill,
  BIconSkipForward,
  BIconSkipForwardBtn,
  BIconSkipForwardBtnFill,
  BIconSkipForwardCircle,
  BIconSkipForwardCircleFill,
  BIconSkipForwardFill,
  BIconSkipStart,
  BIconSkipStartBtn,
  BIconSkipStartBtnFill,
  BIconSkipStartCircle,
  BIconSkipStartCircleFill,
  BIconSkipStartFill,
  BIconSlack,
  BIconSlash,
  BIconSlashCircle,
  BIconSlashCircleFill,
  BIconSlashSquare,
  BIconSlashSquareFill,
  BIconSliders,
  BIconSmartwatch,
  BIconSortAlphaDown,
  BIconSortAlphaDownAlt,
  BIconSortAlphaUp,
  BIconSortAlphaUpAlt,
  BIconSortDown,
  BIconSortDownAlt,
  BIconSortNumericDown,
  BIconSortNumericDownAlt,
  BIconSortNumericUp,
  BIconSortNumericUpAlt,
  BIconSortUp,
  BIconSortUpAlt,
  BIconSoundwave,
  BIconSpeaker,
  BIconSpeakerFill,
  BIconSpellcheck,
  BIconSquare,
  BIconSquareFill,
  BIconSquareHalf,
  BIconStar,
  BIconStarFill,
  BIconStarHalf,
  BIconStickies,
  BIconStickiesFill,
  BIconSticky,
  BIconStickyFill,
  BIconStop,
  BIconStopBtn,
  BIconStopBtnFill,
  BIconStopCircle,
  BIconStopCircleFill,
  BIconStopFill,
  BIconStoplights,
  BIconStoplightsFill,
  BIconStopwatch,
  BIconStopwatchFill,
  BIconSubtract,
  BIconSuitClub,
  BIconSuitClubFill,
  BIconSuitDiamond,
  BIconSuitDiamondFill,
  BIconSuitHeart,
  BIconSuitHeartFill,
  BIconSuitSpade,
  BIconSuitSpadeFill,
  BIconSun,
  BIconSunglasses,
  BIconTable,
  BIconTablet,
  BIconTabletFill,
  BIconTabletLandscape,
  BIconTabletLandscapeFill,
  BIconTag,
  BIconTagFill,
  BIconTags,
  BIconTagsFill,
  BIconTelephone,
  BIconTelephoneFill,
  BIconTelephoneForward,
  BIconTelephoneForwardFill,
  BIconTelephoneInbound,
  BIconTelephoneInboundFill,
  BIconTelephoneMinus,
  BIconTelephoneMinusFill,
  BIconTelephoneOutbound,
  BIconTelephoneOutboundFill,
  BIconTelephonePlus,
  BIconTelephonePlusFill,
  BIconTelephoneX,
  BIconTelephoneXFill,
  BIconTerminal,
  BIconTerminalFill,
  BIconTextCenter,
  BIconTextIndentLeft,
  BIconTextIndentRight,
  BIconTextLeft,
  BIconTextParagraph,
  BIconTextRight,
  BIconTextarea,
  BIconTextareaResize,
  BIconTextareaT,
  BIconThermometer,
  BIconThermometerHalf,
  BIconThreeDots,
  BIconThreeDotsVertical,
  BIconToggle2Off,
  BIconToggle2On,
  BIconToggleOff,
  BIconToggleOn,
  BIconToggles,
  BIconToggles2,
  BIconTools,
  BIconTrash,
  BIconTrash2,
  BIconTrash2Fill,
  BIconTrashFill,
  BIconTree,
  BIconTreeFill,
  BIconTriangle,
  BIconTriangleFill,
  BIconTriangleHalf,
  BIconTrophy,
  BIconTrophyFill,
  BIconTruck,
  BIconTruckFlatbed,
  BIconTv,
  BIconTvFill,
  BIconTwitch,
  BIconTwitter,
  BIconType,
  BIconTypeBold,
  BIconTypeH1,
  BIconTypeH2,
  BIconTypeH3,
  BIconTypeItalic,
  BIconTypeStrikethrough,
  BIconTypeUnderline,
  BIconUiChecks,
  BIconUiChecksGrid,
  BIconUiRadios,
  BIconUiRadiosGrid,
  BIconUnion,
  BIconUnlock,
  BIconUnlockFill,
  BIconUpc,
  BIconUpcScan,
  BIconUpload,
  BIconVectorPen,
  BIconViewList,
  BIconViewStacked,
  BIconVinyl,
  BIconVinylFill,
  BIconVoicemail,
  BIconVolumeDown,
  BIconVolumeDownFill,
  BIconVolumeMute,
  BIconVolumeMuteFill,
  BIconVolumeOff,
  BIconVolumeOffFill,
  BIconVolumeUp,
  BIconVolumeUpFill,
  BIconVr,
  BIconWallet,
  BIconWallet2,
  BIconWalletFill,
  BIconWatch,
  BIconWifi,
  BIconWifi1,
  BIconWifi2,
  BIconWifiOff,
  BIconWindow,
  BIconWrench,
  BIconX,
  BIconXCircle,
  BIconXCircleFill,
  BIconXDiamond,
  BIconXDiamondFill,
  BIconXOctagon,
  BIconXOctagonFill,
  BIconXSquare,
  BIconXSquareFill,
  BIconYoutube,
  BIconZoomIn,
  BIconZoomOut
} from './icons'

// Icon component names for used in the docs
export const iconNames = [
  // BootstrapVue custom icon component names
  'BIconBlank',
  // Bootstrap icon component names
  'BIconAlarm',
  'BIconAlarmFill',
  'BIconAlignBottom',
  'BIconAlignCenter',
  'BIconAlignEnd',
  'BIconAlignMiddle',
  'BIconAlignStart',
  'BIconAlignTop',
  'BIconAlt',
  'BIconApp',
  'BIconAppIndicator',
  'BIconArchive',
  'BIconArchiveFill',
  'BIconArrow90degDown',
  'BIconArrow90degLeft',
  'BIconArrow90degRight',
  'BIconArrow90degUp',
  'BIconArrowBarDown',
  'BIconArrowBarLeft',
  'BIconArrowBarRight',
  'BIconArrowBarUp',
  'BIconArrowClockwise',
  'BIconArrowCounterclockwise',
  'BIconArrowDown',
  'BIconArrowDownCircle',
  'BIconArrowDownCircleFill',
  'BIconArrowDownLeft',
  'BIconArrowDownLeftCircle',
  'BIconArrowDownLeftCircleFill',
  'BIconArrowDownLeftSquare',
  'BIconArrowDownLeftSquareFill',
  'BIconArrowDownRight',
  'BIconArrowDownRightCircle',
  'BIconArrowDownRightCircleFill',
  'BIconArrowDownRightSquare',
  'BIconArrowDownRightSquareFill',
  'BIconArrowDownShort',
  'BIconArrowDownSquare',
  'BIconArrowDownSquareFill',
  'BIconArrowDownUp',
  'BIconArrowLeft',
  'BIconArrowLeftCircle',
  'BIconArrowLeftCircleFill',
  'BIconArrowLeftRight',
  'BIconArrowLeftShort',
  'BIconArrowLeftSquare',
  'BIconArrowLeftSquareFill',
  'BIconArrowRepeat',
  'BIconArrowReturnLeft',
  'BIconArrowReturnRight',
  'BIconArrowRight',
  'BIconArrowRightCircle',
  'BIconArrowRightCircleFill',
  'BIconArrowRightShort',
  'BIconArrowRightSquare',
  'BIconArrowRightSquareFill',
  'BIconArrowUp',
  'BIconArrowUpCircle',
  'BIconArrowUpCircleFill',
  'BIconArrowUpLeft',
  'BIconArrowUpLeftCircle',
  'BIconArrowUpLeftCircleFill',
  'BIconArrowUpLeftSquare',
  'BIconArrowUpLeftSquareFill',
  'BIconArrowUpRight',
  'BIconArrowUpRightCircle',
  'BIconArrowUpRightCircleFill',
  'BIconArrowUpRightSquare',
  'BIconArrowUpRightSquareFill',
  'BIconArrowUpShort',
  'BIconArrowUpSquare',
  'BIconArrowUpSquareFill',
  'BIconArrowsAngleContract',
  'BIconArrowsAngleExpand',
  'BIconArrowsCollapse',
  'BIconArrowsExpand',
  'BIconArrowsFullscreen',
  'BIconArrowsMove',
  'BIconAspectRatio',
  'BIconAspectRatioFill',
  'BIconAsterisk',
  'BIconAt',
  'BIconAward',
  'BIconAwardFill',
  'BIconBack',
  'BIconBackspace',
  'BIconBackspaceFill',
  'BIconBackspaceReverse',
  'BIconBackspaceReverseFill',
  'BIconBadge4k',
  'BIconBadge4kFill',
  'BIconBadge8k',
  'BIconBadge8kFill',
  'BIconBadgeAd',
  'BIconBadgeAdFill',
  'BIconBadgeCc',
  'BIconBadgeCcFill',
  'BIconBadgeHd',
  'BIconBadgeHdFill',
  'BIconBadgeTm',
  'BIconBadgeTmFill',
  'BIconBadgeVo',
  'BIconBadgeVoFill',
  'BIconBag',
  'BIconBagCheck',
  'BIconBagCheckFill',
  'BIconBagDash',
  'BIconBagDashFill',
  'BIconBagFill',
  'BIconBagPlus',
  'BIconBagPlusFill',
  'BIconBagX',
  'BIconBagXFill',
  'BIconBarChart',
  'BIconBarChartFill',
  'BIconBarChartLine',
  'BIconBarChartLineFill',
  'BIconBarChartSteps',
  'BIconBasket',
  'BIconBasket2',
  'BIconBasket2Fill',
  'BIconBasket3',
  'BIconBasket3Fill',
  'BIconBasketFill',
  'BIconBattery',
  'BIconBatteryCharging',
  'BIconBatteryFull',
  'BIconBatteryHalf',
  'BIconBell',
  'BIconBellFill',
  'BIconBezier',
  'BIconBezier2',
  'BIconBicycle',
  'BIconBinoculars',
  'BIconBinocularsFill',
  'BIconBlockquoteLeft',
  'BIconBlockquoteRight',
  'BIconBook',
  'BIconBookFill',
  'BIconBookHalf',
  'BIconBookmark',
  'BIconBookmarkCheck',
  'BIconBookmarkCheckFill',
  'BIconBookmarkDash',
  'BIconBookmarkDashFill',
  'BIconBookmarkFill',
  'BIconBookmarkHeart',
  'BIconBookmarkHeartFill',
  'BIconBookmarkPlus',
  'BIconBookmarkPlusFill',
  'BIconBookmarkStar',
  'BIconBookmarkStarFill',
  'BIconBookmarkX',
  'BIconBookmarkXFill',
  'BIconBookmarks',
  'BIconBookmarksFill',
  'BIconBookshelf',
  'BIconBootstrap',
  'BIconBootstrapFill',
  'BIconBootstrapReboot',
  'BIconBorderStyle',
  'BIconBorderWidth',
  'BIconBoundingBox',
  'BIconBoundingBoxCircles',
  'BIconBox',
  'BIconBoxArrowDown',
  'BIconBoxArrowDownLeft',
  'BIconBoxArrowDownRight',
  'BIconBoxArrowInDown',
  'BIconBoxArrowInDownLeft',
  'BIconBoxArrowInDownRight',
  'BIconBoxArrowInLeft',
  'BIconBoxArrowInRight',
  'BIconBoxArrowInUp',
  'BIconBoxArrowInUpLeft',
  'BIconBoxArrowInUpRight',
  'BIconBoxArrowLeft',
  'BIconBoxArrowRight',
  'BIconBoxArrowUp',
  'BIconBoxArrowUpLeft',
  'BIconBoxArrowUpRight',
  'BIconBoxSeam',
  'BIconBraces',
  'BIconBricks',
  'BIconBriefcase',
  'BIconBriefcaseFill',
  'BIconBrightnessAltHigh',
  'BIconBrightnessAltHighFill',
  'BIconBrightnessAltLow',
  'BIconBrightnessAltLowFill',
  'BIconBrightnessHigh',
  'BIconBrightnessHighFill',
  'BIconBrightnessLow',
  'BIconBrightnessLowFill',
  'BIconBroadcast',
  'BIconBroadcastPin',
  'BIconBrush',
  'BIconBrushFill',
  'BIconBucket',
  'BIconBucketFill',
  'BIconBug',
  'BIconBugFill',
  'BIconBuilding',
  'BIconBullseye',
  'BIconCalculator',
  'BIconCalculatorFill',
  'BIconCalendar',
  'BIconCalendar2',
  'BIconCalendar2Check',
  'BIconCalendar2CheckFill',
  'BIconCalendar2Date',
  'BIconCalendar2DateFill',
  'BIconCalendar2Day',
  'BIconCalendar2DayFill',
  'BIconCalendar2Event',
  'BIconCalendar2EventFill',
  'BIconCalendar2Fill',
  'BIconCalendar2Minus',
  'BIconCalendar2MinusFill',
  'BIconCalendar2Month',
  'BIconCalendar2MonthFill',
  'BIconCalendar2Plus',
  'BIconCalendar2PlusFill',
  'BIconCalendar2Range',
  'BIconCalendar2RangeFill',
  'BIconCalendar2Week',
  'BIconCalendar2WeekFill',
  'BIconCalendar2X',
  'BIconCalendar2XFill',
  'BIconCalendar3',
  'BIconCalendar3Event',
  'BIconCalendar3EventFill',
  'BIconCalendar3Fill',
  'BIconCalendar3Range',
  'BIconCalendar3RangeFill',
  'BIconCalendar3Week',
  'BIconCalendar3WeekFill',
  'BIconCalendar4',
  'BIconCalendar4Event',
  'BIconCalendar4Range',
  'BIconCalendar4Week',
  'BIconCalendarCheck',
  'BIconCalendarCheckFill',
  'BIconCalendarDate',
  'BIconCalendarDateFill',
  'BIconCalendarDay',
  'BIconCalendarDayFill',
  'BIconCalendarEvent',
  'BIconCalendarEventFill',
  'BIconCalendarFill',
  'BIconCalendarMinus',
  'BIconCalendarMinusFill',
  'BIconCalendarMonth',
  'BIconCalendarMonthFill',
  'BIconCalendarPlus',
  'BIconCalendarPlusFill',
  'BIconCalendarRange',
  'BIconCalendarRangeFill',
  'BIconCalendarWeek',
  'BIconCalendarWeekFill',
  'BIconCalendarX',
  'BIconCalendarXFill',
  'BIconCamera',
  'BIconCamera2',
  'BIconCameraFill',
  'BIconCameraReels',
  'BIconCameraReelsFill',
  'BIconCameraVideo',
  'BIconCameraVideoFill',
  'BIconCameraVideoOff',
  'BIconCameraVideoOffFill',
  'BIconCapslock',
  'BIconCapslockFill',
  'BIconCardChecklist',
  'BIconCardHeading',
  'BIconCardImage',
  'BIconCardList',
  'BIconCardText',
  'BIconCaretDown',
  'BIconCaretDownFill',
  'BIconCaretDownSquare',
  'BIconCaretDownSquareFill',
  'BIconCaretLeft',
  'BIconCaretLeftFill',
  'BIconCaretLeftSquare',
  'BIconCaretLeftSquareFill',
  'BIconCaretRight',
  'BIconCaretRightFill',
  'BIconCaretRightSquare',
  'BIconCaretRightSquareFill',
  'BIconCaretUp',
  'BIconCaretUpFill',
  'BIconCaretUpSquare',
  'BIconCaretUpSquareFill',
  'BIconCart',
  'BIconCart2',
  'BIconCart3',
  'BIconCart4',
  'BIconCartCheck',
  'BIconCartCheckFill',
  'BIconCartDash',
  'BIconCartDashFill',
  'BIconCartFill',
  'BIconCartPlus',
  'BIconCartPlusFill',
  'BIconCartX',
  'BIconCartXFill',
  'BIconCash',
  'BIconCashStack',
  'BIconCast',
  'BIconChat',
  'BIconChatDots',
  'BIconChatDotsFill',
  'BIconChatFill',
  'BIconChatLeft',
  'BIconChatLeftDots',
  'BIconChatLeftDotsFill',
  'BIconChatLeftFill',
  'BIconChatLeftQuote',
  'BIconChatLeftQuoteFill',
  'BIconChatLeftText',
  'BIconChatLeftTextFill',
  'BIconChatQuote',
  'BIconChatQuoteFill',
  'BIconChatRight',
  'BIconChatRightDots',
  'BIconChatRightDotsFill',
  'BIconChatRightFill',
  'BIconChatRightQuote',
  'BIconChatRightQuoteFill',
  'BIconChatRightText',
  'BIconChatRightTextFill',
  'BIconChatSquare',
  'BIconChatSquareDots',
  'BIconChatSquareDotsFill',
  'BIconChatSquareFill',
  'BIconChatSquareQuote',
  'BIconChatSquareQuoteFill',
  'BIconChatSquareText',
  'BIconChatSquareTextFill',
  'BIconChatText',
  'BIconChatTextFill',
  'BIconCheck',
  'BIconCheck2',
  'BIconCheck2All',
  'BIconCheck2Circle',
  'BIconCheck2Square',
  'BIconCheckAll',
  'BIconCheckCircle',
  'BIconCheckCircleFill',
  'BIconCheckSquare',
  'BIconCheckSquareFill',
  'BIconChevronBarContract',
  'BIconChevronBarDown',
  'BIconChevronBarExpand',
  'BIconChevronBarLeft',
  'BIconChevronBarRight',
  'BIconChevronBarUp',
  'BIconChevronCompactDown',
  'BIconChevronCompactLeft',
  'BIconChevronCompactRight',
  'BIconChevronCompactUp',
  'BIconChevronContract',
  'BIconChevronDoubleDown',
  'BIconChevronDoubleLeft',
  'BIconChevronDoubleRight',
  'BIconChevronDoubleUp',
  'BIconChevronDown',
  'BIconChevronExpand',
  'BIconChevronLeft',
  'BIconChevronRight',
  'BIconChevronUp',
  'BIconCircle',
  'BIconCircleFill',
  'BIconCircleHalf',
  'BIconCircleSquare',
  'BIconClipboard',
  'BIconClipboardCheck',
  'BIconClipboardData',
  'BIconClipboardMinus',
  'BIconClipboardPlus',
  'BIconClipboardX',
  'BIconClock',
  'BIconClockFill',
  'BIconClockHistory',
  'BIconCloud',
  'BIconCloudArrowDown',
  'BIconCloudArrowDownFill',
  'BIconCloudArrowUp',
  'BIconCloudArrowUpFill',
  'BIconCloudCheck',
  'BIconCloudCheckFill',
  'BIconCloudDownload',
  'BIconCloudDownloadFill',
  'BIconCloudFill',
  'BIconCloudMinus',
  'BIconCloudMinusFill',
  'BIconCloudPlus',
  'BIconCloudPlusFill',
  'BIconCloudSlash',
  'BIconCloudSlashFill',
  'BIconCloudUpload',
  'BIconCloudUploadFill',
  'BIconCode',
  'BIconCodeSlash',
  'BIconCodeSquare',
  'BIconCollection',
  'BIconCollectionFill',
  'BIconCollectionPlay',
  'BIconCollectionPlayFill',
  'BIconColumns',
  'BIconColumnsGap',
  'BIconCommand',
  'BIconCompass',
  'BIconCompassFill',
  'BIconCone',
  'BIconConeStriped',
  'BIconController',
  'BIconCpu',
  'BIconCpuFill',
  'BIconCreditCard',
  'BIconCreditCard2Back',
  'BIconCreditCard2BackFill',
  'BIconCreditCard2Front',
  'BIconCreditCard2FrontFill',
  'BIconCreditCardFill',
  'BIconCrop',
  'BIconCup',
  'BIconCupFill',
  'BIconCupStraw',
  'BIconCursor',
  'BIconCursorFill',
  'BIconCursorText',
  'BIconDash',
  'BIconDashCircle',
  'BIconDashCircleFill',
  'BIconDashSquare',
  'BIconDashSquareFill',
  'BIconDiagram2',
  'BIconDiagram2Fill',
  'BIconDiagram3',
  'BIconDiagram3Fill',
  'BIconDiamond',
  'BIconDiamondFill',
  'BIconDiamondHalf',
  'BIconDice1',
  'BIconDice1Fill',
  'BIconDice2',
  'BIconDice2Fill',
  'BIconDice3',
  'BIconDice3Fill',
  'BIconDice4',
  'BIconDice4Fill',
  'BIconDice5',
  'BIconDice5Fill',
  'BIconDice6',
  'BIconDice6Fill',
  'BIconDisc',
  'BIconDiscFill',
  'BIconDiscord',
  'BIconDisplay',
  'BIconDisplayFill',
  'BIconDistributeHorizontal',
  'BIconDistributeVertical',
  'BIconDoorClosed',
  'BIconDoorClosedFill',
  'BIconDoorOpen',
  'BIconDoorOpenFill',
  'BIconDot',
  'BIconDownload',
  'BIconDroplet',
  'BIconDropletFill',
  'BIconDropletHalf',
  'BIconEarbuds',
  'BIconEasel',
  'BIconEaselFill',
  'BIconEgg',
  'BIconEggFill',
  'BIconEggFried',
  'BIconEject',
  'BIconEjectFill',
  'BIconEmojiAngry',
  'BIconEmojiAngryFill',
  'BIconEmojiDizzy',
  'BIconEmojiDizzyFill',
  'BIconEmojiExpressionless',
  'BIconEmojiExpressionlessFill',
  'BIconEmojiFrown',
  'BIconEmojiFrownFill',
  'BIconEmojiHeartEyes',
  'BIconEmojiHeartEyesFill',
  'BIconEmojiLaughing',
  'BIconEmojiLaughingFill',
  'BIconEmojiNeutral',
  'BIconEmojiNeutralFill',
  'BIconEmojiSmile',
  'BIconEmojiSmileFill',
  'BIconEmojiSmileUpsideDown',
  'BIconEmojiSmileUpsideDownFill',
  'BIconEmojiSunglasses',
  'BIconEmojiSunglassesFill',
  'BIconEmojiWink',
  'BIconEmojiWinkFill',
  'BIconEnvelope',
  'BIconEnvelopeFill',
  'BIconEnvelopeOpen',
  'BIconEnvelopeOpenFill',
  'BIconExclamation',
  'BIconExclamationCircle',
  'BIconExclamationCircleFill',
  'BIconExclamationDiamond',
  'BIconExclamationDiamondFill',
  'BIconExclamationOctagon',
  'BIconExclamationOctagonFill',
  'BIconExclamationSquare',
  'BIconExclamationSquareFill',
  'BIconExclamationTriangle',
  'BIconExclamationTriangleFill',
  'BIconExclude',
  'BIconEye',
  'BIconEyeFill',
  'BIconEyeSlash',
  'BIconEyeSlashFill',
  'BIconEyeglasses',
  'BIconFacebook',
  'BIconFile',
  'BIconFileArrowDown',
  'BIconFileArrowDownFill',
  'BIconFileArrowUp',
  'BIconFileArrowUpFill',
  'BIconFileBarGraph',
  'BIconFileBarGraphFill',
  'BIconFileBinary',
  'BIconFileBinaryFill',
  'BIconFileBreak',
  'BIconFileBreakFill',
  'BIconFileCheck',
  'BIconFileCheckFill',
  'BIconFileCode',
  'BIconFileCodeFill',
  'BIconFileDiff',
  'BIconFileDiffFill',
  'BIconFileEarmark',
  'BIconFileEarmarkArrowDown',
  'BIconFileEarmarkArrowDownFill',
  'BIconFileEarmarkArrowUp',
  'BIconFileEarmarkArrowUpFill',
  'BIconFileEarmarkBarGraph',
  'BIconFileEarmarkBarGraphFill',
  'BIconFileEarmarkBinary',
  'BIconFileEarmarkBinaryFill',
  'BIconFileEarmarkBreak',
  'BIconFileEarmarkBreakFill',
  'BIconFileEarmarkCheck',
  'BIconFileEarmarkCheckFill',
  'BIconFileEarmarkCode',
  'BIconFileEarmarkCodeFill',
  'BIconFileEarmarkDiff',
  'BIconFileEarmarkDiffFill',
  'BIconFileEarmarkEasel',
  'BIconFileEarmarkEaselFill',
  'BIconFileEarmarkExcel',
  'BIconFileEarmarkExcelFill',
  'BIconFileEarmarkFill',
  'BIconFileEarmarkFont',
  'BIconFileEarmarkFontFill',
  'BIconFileEarmarkImage',
  'BIconFileEarmarkImageFill',
  'BIconFileEarmarkLock',
  'BIconFileEarmarkLock2',
  'BIconFileEarmarkLock2Fill',
  'BIconFileEarmarkLockFill',
  'BIconFileEarmarkMedical',
  'BIconFileEarmarkMedicalFill',
  'BIconFileEarmarkMinus',
  'BIconFileEarmarkMinusFill',
  'BIconFileEarmarkMusic',
  'BIconFileEarmarkMusicFill',
  'BIconFileEarmarkPerson',
  'BIconFileEarmarkPersonFill',
  'BIconFileEarmarkPlay',
  'BIconFileEarmarkPlayFill',
  'BIconFileEarmarkPlus',
  'BIconFileEarmarkPlusFill',
  'BIconFileEarmarkPost',
  'BIconFileEarmarkPostFill',
  'BIconFileEarmarkPpt',
  'BIconFileEarmarkPptFill',
  'BIconFileEarmarkRichtext',
  'BIconFileEarmarkRichtextFill',
  'BIconFileEarmarkRuled',
  'BIconFileEarmarkRuledFill',
  'BIconFileEarmarkSlides',
  'BIconFileEarmarkSlidesFill',
  'BIconFileEarmarkSpreadsheet',
  'BIconFileEarmarkSpreadsheetFill',
  'BIconFileEarmarkText',
  'BIconFileEarmarkTextFill',
  'BIconFileEarmarkWord',
  'BIconFileEarmarkWordFill',
  'BIconFileEarmarkX',
  'BIconFileEarmarkXFill',
  'BIconFileEarmarkZip',
  'BIconFileEarmarkZipFill',
  'BIconFileEasel',
  'BIconFileEaselFill',
  'BIconFileExcel',
  'BIconFileExcelFill',
  'BIconFileFill',
  'BIconFileFont',
  'BIconFileFontFill',
  'BIconFileImage',
  'BIconFileImageFill',
  'BIconFileLock',
  'BIconFileLock2',
  'BIconFileLock2Fill',
  'BIconFileLockFill',
  'BIconFileMedical',
  'BIconFileMedicalFill',
  'BIconFileMinus',
  'BIconFileMinusFill',
  'BIconFileMusic',
  'BIconFileMusicFill',
  'BIconFilePerson',
  'BIconFilePersonFill',
  'BIconFilePlay',
  'BIconFilePlayFill',
  'BIconFilePlus',
  'BIconFilePlusFill',
  'BIconFilePost',
  'BIconFilePostFill',
  'BIconFilePpt',
  'BIconFilePptFill',
  'BIconFileRichtext',
  'BIconFileRichtextFill',
  'BIconFileRuled',
  'BIconFileRuledFill',
  'BIconFileSlides',
  'BIconFileSlidesFill',
  'BIconFileSpreadsheet',
  'BIconFileSpreadsheetFill',
  'BIconFileText',
  'BIconFileTextFill',
  'BIconFileWord',
  'BIconFileWordFill',
  'BIconFileX',
  'BIconFileXFill',
  'BIconFileZip',
  'BIconFileZipFill',
  'BIconFiles',
  'BIconFilesAlt',
  'BIconFilm',
  'BIconFilter',
  'BIconFilterCircle',
  'BIconFilterCircleFill',
  'BIconFilterLeft',
  'BIconFilterRight',
  'BIconFilterSquare',
  'BIconFilterSquareFill',
  'BIconFlag',
  'BIconFlagFill',
  'BIconFlower1',
  'BIconFlower2',
  'BIconFlower3',
  'BIconFolder',
  'BIconFolder2',
  'BIconFolder2Open',
  'BIconFolderCheck',
  'BIconFolderFill',
  'BIconFolderMinus',
  'BIconFolderPlus',
  'BIconFolderSymlink',
  'BIconFolderSymlinkFill',
  'BIconFolderX',
  'BIconFonts',
  'BIconForward',
  'BIconForwardFill',
  'BIconFront',
  'BIconFullscreen',
  'BIconFullscreenExit',
  'BIconFunnel',
  'BIconFunnelFill',
  'BIconGear',
  'BIconGearFill',
  'BIconGearWide',
  'BIconGearWideConnected',
  'BIconGem',
  'BIconGeo',
  'BIconGeoAlt',
  'BIconGeoAltFill',
  'BIconGeoFill',
  'BIconGift',
  'BIconGiftFill',
  'BIconGithub',
  'BIconGlobe',
  'BIconGlobe2',
  'BIconGoogle',
  'BIconGraphDown',
  'BIconGraphUp',
  'BIconGrid',
  'BIconGrid1x2',
  'BIconGrid1x2Fill',
  'BIconGrid3x2',
  'BIconGrid3x2Gap',
  'BIconGrid3x2GapFill',
  'BIconGrid3x3',
  'BIconGrid3x3Gap',
  'BIconGrid3x3GapFill',
  'BIconGridFill',
  'BIconGripHorizontal',
  'BIconGripVertical',
  'BIconHammer',
  'BIconHandIndex',
  'BIconHandIndexThumb',
  'BIconHandThumbsDown',
  'BIconHandThumbsUp',
  'BIconHandbag',
  'BIconHandbagFill',
  'BIconHash',
  'BIconHdd',
  'BIconHddFill',
  'BIconHddNetwork',
  'BIconHddNetworkFill',
  'BIconHddRack',
  'BIconHddRackFill',
  'BIconHddStack',
  'BIconHddStackFill',
  'BIconHeadphones',
  'BIconHeadset',
  'BIconHeart',
  'BIconHeartFill',
  'BIconHeartHalf',
  'BIconHeptagon',
  'BIconHeptagonFill',
  'BIconHeptagonHalf',
  'BIconHexagon',
  'BIconHexagonFill',
  'BIconHexagonHalf',
  'BIconHourglass',
  'BIconHourglassBottom',
  'BIconHourglassSplit',
  'BIconHourglassTop',
  'BIconHouse',
  'BIconHouseDoor',
  'BIconHouseDoorFill',
  'BIconHouseFill',
  'BIconHr',
  'BIconImage',
  'BIconImageAlt',
  'BIconImageFill',
  'BIconImages',
  'BIconInbox',
  'BIconInboxFill',
  'BIconInboxes',
  'BIconInboxesFill',
  'BIconInfo',
  'BIconInfoCircle',
  'BIconInfoCircleFill',
  'BIconInfoSquare',
  'BIconInfoSquareFill',
  'BIconInputCursor',
  'BIconInputCursorText',
  'BIconInstagram',
  'BIconIntersect',
  'BIconJournal',
  'BIconJournalAlbum',
  'BIconJournalArrowDown',
  'BIconJournalArrowUp',
  'BIconJournalBookmark',
  'BIconJournalBookmarkFill',
  'BIconJournalCheck',
  'BIconJournalCode',
  'BIconJournalMedical',
  'BIconJournalMinus',
  'BIconJournalPlus',
  'BIconJournalRichtext',
  'BIconJournalText',
  'BIconJournalX',
  'BIconJournals',
  'BIconJoystick',
  'BIconJustify',
  'BIconJustifyLeft',
  'BIconJustifyRight',
  'BIconKanban',
  'BIconKanbanFill',
  'BIconKey',
  'BIconKeyFill',
  'BIconKeyboard',
  'BIconKeyboardFill',
  'BIconLadder',
  'BIconLamp',
  'BIconLampFill',
  'BIconLaptop',
  'BIconLaptopFill',
  'BIconLayers',
  'BIconLayersFill',
  'BIconLayersHalf',
  'BIconLayoutSidebar',
  'BIconLayoutSidebarInset',
  'BIconLayoutSidebarInsetReverse',
  'BIconLayoutSidebarReverse',
  'BIconLayoutSplit',
  'BIconLayoutTextSidebar',
  'BIconLayoutTextSidebarReverse',
  'BIconLayoutTextWindow',
  'BIconLayoutTextWindowReverse',
  'BIconLayoutThreeColumns',
  'BIconLayoutWtf',
  'BIconLifePreserver',
  'BIconLightning',
  'BIconLightningFill',
  'BIconLink',
  'BIconLink45deg',
  'BIconLinkedin',
  'BIconList',
  'BIconListCheck',
  'BIconListNested',
  'BIconListOl',
  'BIconListStars',
  'BIconListTask',
  'BIconListUl',
  'BIconLock',
  'BIconLockFill',
  'BIconMailbox',
  'BIconMailbox2',
  'BIconMap',
  'BIconMapFill',
  'BIconMarkdown',
  'BIconMarkdownFill',
  'BIconMenuApp',
  'BIconMenuAppFill',
  'BIconMenuButton',
  'BIconMenuButtonFill',
  'BIconMenuButtonWide',
  'BIconMenuButtonWideFill',
  'BIconMenuDown',
  'BIconMenuUp',
  'BIconMic',
  'BIconMicFill',
  'BIconMicMute',
  'BIconMicMuteFill',
  'BIconMinecart',
  'BIconMinecartLoaded',
  'BIconMoon',
  'BIconMouse',
  'BIconMouse2',
  'BIconMouse3',
  'BIconMusicNote',
  'BIconMusicNoteBeamed',
  'BIconMusicNoteList',
  'BIconMusicPlayer',
  'BIconMusicPlayerFill',
  'BIconNewspaper',
  'BIconNodeMinus',
  'BIconNodeMinusFill',
  'BIconNodePlus',
  'BIconNodePlusFill',
  'BIconNut',
  'BIconNutFill',
  'BIconOctagon',
  'BIconOctagonFill',
  'BIconOctagonHalf',
  'BIconOption',
  'BIconOutlet',
  'BIconPaperclip',
  'BIconParagraph',
  'BIconPatchCheck',
  'BIconPatchCheckFill',
  'BIconPatchExclamation',
  'BIconPatchExclamationFill',
  'BIconPatchMinus',
  'BIconPatchMinusFill',
  'BIconPatchPlus',
  'BIconPatchPlusFill',
  'BIconPatchQuestion',
  'BIconPatchQuestionFill',
  'BIconPause',
  'BIconPauseBtn',
  'BIconPauseBtnFill',
  'BIconPauseCircle',
  'BIconPauseCircleFill',
  'BIconPauseFill',
  'BIconPeace',
  'BIconPeaceFill',
  'BIconPen',
  'BIconPenFill',
  'BIconPencil',
  'BIconPencilFill',
  'BIconPencilSquare',
  'BIconPentagon',
  'BIconPentagonFill',
  'BIconPentagonHalf',
  'BIconPeople',
  'BIconPeopleFill',
  'BIconPercent',
  'BIconPerson',
  'BIconPersonBadge',
  'BIconPersonBadgeFill',
  'BIconPersonBoundingBox',
  'BIconPersonCheck',
  'BIconPersonCheckFill',
  'BIconPersonCircle',
  'BIconPersonDash',
  'BIconPersonDashFill',
  'BIconPersonFill',
  'BIconPersonLinesFill',
  'BIconPersonPlus',
  'BIconPersonPlusFill',
  'BIconPersonSquare',
  'BIconPersonX',
  'BIconPersonXFill',
  'BIconPhone',
  'BIconPhoneFill',
  'BIconPhoneLandscape',
  'BIconPhoneLandscapeFill',
  'BIconPhoneVibrate',
  'BIconPieChart',
  'BIconPieChartFill',
  'BIconPip',
  'BIconPipFill',
  'BIconPlay',
  'BIconPlayBtn',
  'BIconPlayBtnFill',
  'BIconPlayCircle',
  'BIconPlayCircleFill',
  'BIconPlayFill',
  'BIconPlug',
  'BIconPlugFill',
  'BIconPlus',
  'BIconPlusCircle',
  'BIconPlusCircleFill',
  'BIconPlusSquare',
  'BIconPlusSquareFill',
  'BIconPower',
  'BIconPrinter',
  'BIconPrinterFill',
  'BIconPuzzle',
  'BIconPuzzleFill',
  'BIconQuestion',
  'BIconQuestionCircle',
  'BIconQuestionCircleFill',
  'BIconQuestionDiamond',
  'BIconQuestionDiamondFill',
  'BIconQuestionOctagon',
  'BIconQuestionOctagonFill',
  'BIconQuestionSquare',
  'BIconQuestionSquareFill',
  'BIconReceipt',
  'BIconReceiptCutoff',
  'BIconReception0',
  'BIconReception1',
  'BIconReception2',
  'BIconReception3',
  'BIconReception4',
  'BIconRecord',
  'BIconRecord2',
  'BIconRecord2Fill',
  'BIconRecordBtn',
  'BIconRecordBtnFill',
  'BIconRecordCircle',
  'BIconRecordCircleFill',
  'BIconRecordFill',
  'BIconReply',
  'BIconReplyAll',
  'BIconReplyAllFill',
  'BIconReplyFill',
  'BIconRss',
  'BIconRssFill',
  'BIconScissors',
  'BIconScrewdriver',
  'BIconSearch',
  'BIconSegmentedNav',
  'BIconServer',
  'BIconShare',
  'BIconShareFill',
  'BIconShield',
  'BIconShieldCheck',
  'BIconShieldExclamation',
  'BIconShieldFill',
  'BIconShieldFillCheck',
  'BIconShieldFillExclamation',
  'BIconShieldFillMinus',
  'BIconShieldFillPlus',
  'BIconShieldFillX',
  'BIconShieldLock',
  'BIconShieldLockFill',
  'BIconShieldMinus',
  'BIconShieldPlus',
  'BIconShieldShaded',
  'BIconShieldSlash',
  'BIconShieldSlashFill',
  'BIconShieldX',
  'BIconShift',
  'BIconShiftFill',
  'BIconShop',
  'BIconShopWindow',
  'BIconShuffle',
  'BIconSignpost',
  'BIconSignpost2',
  'BIconSignpost2Fill',
  'BIconSignpostFill',
  'BIconSignpostSplit',
  'BIconSignpostSplitFill',
  'BIconSim',
  'BIconSimFill',
  'BIconSkipBackward',
  'BIconSkipBackwardBtn',
  'BIconSkipBackwardBtnFill',
  'BIconSkipBackwardCircle',
  'BIconSkipBackwardCircleFill',
  'BIconSkipBackwardFill',
  'BIconSkipEnd',
  'BIconSkipEndBtn',
  'BIconSkipEndBtnFill',
  'BIconSkipEndCircle',
  'BIconSkipEndCircleFill',
  'BIconSkipEndFill',
  'BIconSkipForward',
  'BIconSkipForwardBtn',
  'BIconSkipForwardBtnFill',
  'BIconSkipForwardCircle',
  'BIconSkipForwardCircleFill',
  'BIconSkipForwardFill',
  'BIconSkipStart',
  'BIconSkipStartBtn',
  'BIconSkipStartBtnFill',
  'BIconSkipStartCircle',
  'BIconSkipStartCircleFill',
  'BIconSkipStartFill',
  'BIconSlack',
  'BIconSlash',
  'BIconSlashCircle',
  'BIconSlashCircleFill',
  'BIconSlashSquare',
  'BIconSlashSquareFill',
  'BIconSliders',
  'BIconSmartwatch',
  'BIconSortAlphaDown',
  'BIconSortAlphaDownAlt',
  'BIconSortAlphaUp',
  'BIconSortAlphaUpAlt',
  'BIconSortDown',
  'BIconSortDownAlt',
  'BIconSortNumericDown',
  'BIconSortNumericDownAlt',
  'BIconSortNumericUp',
  'BIconSortNumericUpAlt',
  'BIconSortUp',
  'BIconSortUpAlt',
  'BIconSoundwave',
  'BIconSpeaker',
  'BIconSpeakerFill',
  'BIconSpellcheck',
  'BIconSquare',
  'BIconSquareFill',
  'BIconSquareHalf',
  'BIconStar',
  'BIconStarFill',
  'BIconStarHalf',
  'BIconStickies',
  'BIconStickiesFill',
  'BIconSticky',
  'BIconStickyFill',
  'BIconStop',
  'BIconStopBtn',
  'BIconStopBtnFill',
  'BIconStopCircle',
  'BIconStopCircleFill',
  'BIconStopFill',
  'BIconStoplights',
  'BIconStoplightsFill',
  'BIconStopwatch',
  'BIconStopwatchFill',
  'BIconSubtract',
  'BIconSuitClub',
  'BIconSuitClubFill',
  'BIconSuitDiamond',
  'BIconSuitDiamondFill',
  'BIconSuitHeart',
  'BIconSuitHeartFill',
  'BIconSuitSpade',
  'BIconSuitSpadeFill',
  'BIconSun',
  'BIconSunglasses',
  'BIconTable',
  'BIconTablet',
  'BIconTabletFill',
  'BIconTabletLandscape',
  'BIconTabletLandscapeFill',
  'BIconTag',
  'BIconTagFill',
  'BIconTags',
  'BIconTagsFill',
  'BIconTelephone',
  'BIconTelephoneFill',
  'BIconTelephoneForward',
  'BIconTelephoneForwardFill',
  'BIconTelephoneInbound',
  'BIconTelephoneInboundFill',
  'BIconTelephoneMinus',
  'BIconTelephoneMinusFill',
  'BIconTelephoneOutbound',
  'BIconTelephoneOutboundFill',
  'BIconTelephonePlus',
  'BIconTelephonePlusFill',
  'BIconTelephoneX',
  'BIconTelephoneXFill',
  'BIconTerminal',
  'BIconTerminalFill',
  'BIconTextCenter',
  'BIconTextIndentLeft',
  'BIconTextIndentRight',
  'BIconTextLeft',
  'BIconTextParagraph',
  'BIconTextRight',
  'BIconTextarea',
  'BIconTextareaResize',
  'BIconTextareaT',
  'BIconThermometer',
  'BIconThermometerHalf',
  'BIconThreeDots',
  'BIconThreeDotsVertical',
  'BIconToggle2Off',
  'BIconToggle2On',
  'BIconToggleOff',
  'BIconToggleOn',
  'BIconToggles',
  'BIconToggles2',
  'BIconTools',
  'BIconTrash',
  'BIconTrash2',
  'BIconTrash2Fill',
  'BIconTrashFill',
  'BIconTree',
  'BIconTreeFill',
  'BIconTriangle',
  'BIconTriangleFill',
  'BIconTriangleHalf',
  'BIconTrophy',
  'BIconTrophyFill',
  'BIconTruck',
  'BIconTruckFlatbed',
  'BIconTv',
  'BIconTvFill',
  'BIconTwitch',
  'BIconTwitter',
  'BIconType',
  'BIconTypeBold',
  'BIconTypeH1',
  'BIconTypeH2',
  'BIconTypeH3',
  'BIconTypeItalic',
  'BIconTypeStrikethrough',
  'BIconTypeUnderline',
  'BIconUiChecks',
  'BIconUiChecksGrid',
  'BIconUiRadios',
  'BIconUiRadiosGrid',
  'BIconUnion',
  'BIconUnlock',
  'BIconUnlockFill',
  'BIconUpc',
  'BIconUpcScan',
  'BIconUpload',
  'BIconVectorPen',
  'BIconViewList',
  'BIconViewStacked',
  'BIconVinyl',
  'BIconVinylFill',
  'BIconVoicemail',
  'BIconVolumeDown',
  'BIconVolumeDownFill',
  'BIconVolumeMute',
  'BIconVolumeMuteFill',
  'BIconVolumeOff',
  'BIconVolumeOffFill',
  'BIconVolumeUp',
  'BIconVolumeUpFill',
  'BIconVr',
  'BIconWallet',
  'BIconWallet2',
  'BIconWalletFill',
  'BIconWatch',
  'BIconWifi',
  'BIconWifi1',
  'BIconWifi2',
  'BIconWifiOff',
  'BIconWindow',
  'BIconWrench',
  'BIconX',
  'BIconXCircle',
  'BIconXCircleFill',
  'BIconXDiamond',
  'BIconXDiamondFill',
  'BIconXOctagon',
  'BIconXOctagonFill',
  'BIconXSquare',
  'BIconXSquareFill',
  'BIconYoutube',
  'BIconZoomIn',
  'BIconZoomOut'
]

// Export the icons plugin
export const IconsPlugin = /*#__PURE__*/ pluginFactoryNoConfig({
  components: {
    // Icon helper component
    BIcon,
    // Icon stacking component
    BIconstack,
    // BootstrapVue custom icon components
    BIconBlank,
    // Bootstrap icon components
    BIconAlarm,
    BIconAlarmFill,
    BIconAlignBottom,
    BIconAlignCenter,
    BIconAlignEnd,
    BIconAlignMiddle,
    BIconAlignStart,
    BIconAlignTop,
    BIconAlt,
    BIconApp,
    BIconAppIndicator,
    BIconArchive,
    BIconArchiveFill,
    BIconArrow90degDown,
    BIconArrow90degLeft,
    BIconArrow90degRight,
    BIconArrow90degUp,
    BIconArrowBarDown,
    BIconArrowBarLeft,
    BIconArrowBarRight,
    BIconArrowBarUp,
    BIconArrowClockwise,
    BIconArrowCounterclockwise,
    BIconArrowDown,
    BIconArrowDownCircle,
    BIconArrowDownCircleFill,
    BIconArrowDownLeft,
    BIconArrowDownLeftCircle,
    BIconArrowDownLeftCircleFill,
    BIconArrowDownLeftSquare,
    BIconArrowDownLeftSquareFill,
    BIconArrowDownRight,
    BIconArrowDownRightCircle,
    BIconArrowDownRightCircleFill,
    BIconArrowDownRightSquare,
    BIconArrowDownRightSquareFill,
    BIconArrowDownShort,
    BIconArrowDownSquare,
    BIconArrowDownSquareFill,
    BIconArrowDownUp,
    BIconArrowLeft,
    BIconArrowLeftCircle,
    BIconArrowLeftCircleFill,
    BIconArrowLeftRight,
    BIconArrowLeftShort,
    BIconArrowLeftSquare,
    BIconArrowLeftSquareFill,
    BIconArrowRepeat,
    BIconArrowReturnLeft,
    BIconArrowReturnRight,
    BIconArrowRight,
    BIconArrowRightCircle,
    BIconArrowRightCircleFill,
    BIconArrowRightShort,
    BIconArrowRightSquare,
    BIconArrowRightSquareFill,
    BIconArrowUp,
    BIconArrowUpCircle,
    BIconArrowUpCircleFill,
    BIconArrowUpLeft,
    BIconArrowUpLeftCircle,
    BIconArrowUpLeftCircleFill,
    BIconArrowUpLeftSquare,
    BIconArrowUpLeftSquareFill,
    BIconArrowUpRight,
    BIconArrowUpRightCircle,
    BIconArrowUpRightCircleFill,
    BIconArrowUpRightSquare,
    BIconArrowUpRightSquareFill,
    BIconArrowUpShort,
    BIconArrowUpSquare,
    BIconArrowUpSquareFill,
    BIconArrowsAngleContract,
    BIconArrowsAngleExpand,
    BIconArrowsCollapse,
    BIconArrowsExpand,
    BIconArrowsFullscreen,
    BIconArrowsMove,
    BIconAspectRatio,
    BIconAspectRatioFill,
    BIconAsterisk,
    BIconAt,
    BIconAward,
    BIconAwardFill,
    BIconBack,
    BIconBackspace,
    BIconBackspaceFill,
    BIconBackspaceReverse,
    BIconBackspaceReverseFill,
    BIconBadge4k,
    BIconBadge4kFill,
    BIconBadge8k,
    BIconBadge8kFill,
    BIconBadgeAd,
    BIconBadgeAdFill,
    BIconBadgeCc,
    BIconBadgeCcFill,
    BIconBadgeHd,
    BIconBadgeHdFill,
    BIconBadgeTm,
    BIconBadgeTmFill,
    BIconBadgeVo,
    BIconBadgeVoFill,
    BIconBag,
    BIconBagCheck,
    BIconBagCheckFill,
    BIconBagDash,
    BIconBagDashFill,
    BIconBagFill,
    BIconBagPlus,
    BIconBagPlusFill,
    BIconBagX,
    BIconBagXFill,
    BIconBarChart,
    BIconBarChartFill,
    BIconBarChartLine,
    BIconBarChartLineFill,
    BIconBarChartSteps,
    BIconBasket,
    BIconBasket2,
    BIconBasket2Fill,
    BIconBasket3,
    BIconBasket3Fill,
    BIconBasketFill,
    BIconBattery,
    BIconBatteryCharging,
    BIconBatteryFull,
    BIconBatteryHalf,
    BIconBell,
    BIconBellFill,
    BIconBezier,
    BIconBezier2,
    BIconBicycle,
    BIconBinoculars,
    BIconBinocularsFill,
    BIconBlockquoteLeft,
    BIconBlockquoteRight,
    BIconBook,
    BIconBookFill,
    BIconBookHalf,
    BIconBookmark,
    BIconBookmarkCheck,
    BIconBookmarkCheckFill,
    BIconBookmarkDash,
    BIconBookmarkDashFill,
    BIconBookmarkFill,
    BIconBookmarkHeart,
    BIconBookmarkHeartFill,
    BIconBookmarkPlus,
    BIconBookmarkPlusFill,
    BIconBookmarkStar,
    BIconBookmarkStarFill,
    BIconBookmarkX,
    BIconBookmarkXFill,
    BIconBookmarks,
    BIconBookmarksFill,
    BIconBookshelf,
    BIconBootstrap,
    BIconBootstrapFill,
    BIconBootstrapReboot,
    BIconBorderStyle,
    BIconBorderWidth,
    BIconBoundingBox,
    BIconBoundingBoxCircles,
    BIconBox,
    BIconBoxArrowDown,
    BIconBoxArrowDownLeft,
    BIconBoxArrowDownRight,
    BIconBoxArrowInDown,
    BIconBoxArrowInDownLeft,
    BIconBoxArrowInDownRight,
    BIconBoxArrowInLeft,
    BIconBoxArrowInRight,
    BIconBoxArrowInUp,
    BIconBoxArrowInUpLeft,
    BIconBoxArrowInUpRight,
    BIconBoxArrowLeft,
    BIconBoxArrowRight,
    BIconBoxArrowUp,
    BIconBoxArrowUpLeft,
    BIconBoxArrowUpRight,
    BIconBoxSeam,
    BIconBraces,
    BIconBricks,
    BIconBriefcase,
    BIconBriefcaseFill,
    BIconBrightnessAltHigh,
    BIconBrightnessAltHighFill,
    BIconBrightnessAltLow,
    BIconBrightnessAltLowFill,
    BIconBrightnessHigh,
    BIconBrightnessHighFill,
    BIconBrightnessLow,
    BIconBrightnessLowFill,
    BIconBroadcast,
    BIconBroadcastPin,
    BIconBrush,
    BIconBrushFill,
    BIconBucket,
    BIconBucketFill,
    BIconBug,
    BIconBugFill,
    BIconBuilding,
    BIconBullseye,
    BIconCalculator,
    BIconCalculatorFill,
    BIconCalendar,
    BIconCalendar2,
    BIconCalendar2Check,
    BIconCalendar2CheckFill,
    BIconCalendar2Date,
    BIconCalendar2DateFill,
    BIconCalendar2Day,
    BIconCalendar2DayFill,
    BIconCalendar2Event,
    BIconCalendar2EventFill,
    BIconCalendar2Fill,
    BIconCalendar2Minus,
    BIconCalendar2MinusFill,
    BIconCalendar2Month,
    BIconCalendar2MonthFill,
    BIconCalendar2Plus,
    BIconCalendar2PlusFill,
    BIconCalendar2Range,
    BIconCalendar2RangeFill,
    BIconCalendar2Week,
    BIconCalendar2WeekFill,
    BIconCalendar2X,
    BIconCalendar2XFill,
    BIconCalendar3,
    BIconCalendar3Event,
    BIconCalendar3EventFill,
    BIconCalendar3Fill,
    BIconCalendar3Range,
    BIconCalendar3RangeFill,
    BIconCalendar3Week,
    BIconCalendar3WeekFill,
    BIconCalendar4,
    BIconCalendar4Event,
    BIconCalendar4Range,
    BIconCalendar4Week,
    BIconCalendarCheck,
    BIconCalendarCheckFill,
    BIconCalendarDate,
    BIconCalendarDateFill,
    BIconCalendarDay,
    BIconCalendarDayFill,
    BIconCalendarEvent,
    BIconCalendarEventFill,
    BIconCalendarFill,
    BIconCalendarMinus,
    BIconCalendarMinusFill,
    BIconCalendarMonth,
    BIconCalendarMonthFill,
    BIconCalendarPlus,
    BIconCalendarPlusFill,
    BIconCalendarRange,
    BIconCalendarRangeFill,
    BIconCalendarWeek,
    BIconCalendarWeekFill,
    BIconCalendarX,
    BIconCalendarXFill,
    BIconCamera,
    BIconCamera2,
    BIconCameraFill,
    BIconCameraReels,
    BIconCameraReelsFill,
    BIconCameraVideo,
    BIconCameraVideoFill,
    BIconCameraVideoOff,
    BIconCameraVideoOffFill,
    BIconCapslock,
    BIconCapslockFill,
    BIconCardChecklist,
    BIconCardHeading,
    BIconCardImage,
    BIconCardList,
    BIconCardText,
    BIconCaretDown,
    BIconCaretDownFill,
    BIconCaretDownSquare,
    BIconCaretDownSquareFill,
    BIconCaretLeft,
    BIconCaretLeftFill,
    BIconCaretLeftSquare,
    BIconCaretLeftSquareFill,
    BIconCaretRight,
    BIconCaretRightFill,
    BIconCaretRightSquare,
    BIconCaretRightSquareFill,
    BIconCaretUp,
    BIconCaretUpFill,
    BIconCaretUpSquare,
    BIconCaretUpSquareFill,
    BIconCart,
    BIconCart2,
    BIconCart3,
    BIconCart4,
    BIconCartCheck,
    BIconCartCheckFill,
    BIconCartDash,
    BIconCartDashFill,
    BIconCartFill,
    BIconCartPlus,
    BIconCartPlusFill,
    BIconCartX,
    BIconCartXFill,
    BIconCash,
    BIconCashStack,
    BIconCast,
    BIconChat,
    BIconChatDots,
    BIconChatDotsFill,
    BIconChatFill,
    BIconChatLeft,
    BIconChatLeftDots,
    BIconChatLeftDotsFill,
    BIconChatLeftFill,
    BIconChatLeftQuote,
    BIconChatLeftQuoteFill,
    BIconChatLeftText,
    BIconChatLeftTextFill,
    BIconChatQuote,
    BIconChatQuoteFill,
    BIconChatRight,
    BIconChatRightDots,
    BIconChatRightDotsFill,
    BIconChatRightFill,
    BIconChatRightQuote,
    BIconChatRightQuoteFill,
    BIconChatRightText,
    BIconChatRightTextFill,
    BIconChatSquare,
    BIconChatSquareDots,
    BIconChatSquareDotsFill,
    BIconChatSquareFill,
    BIconChatSquareQuote,
    BIconChatSquareQuoteFill,
    BIconChatSquareText,
    BIconChatSquareTextFill,
    BIconChatText,
    BIconChatTextFill,
    BIconCheck,
    BIconCheck2,
    BIconCheck2All,
    BIconCheck2Circle,
    BIconCheck2Square,
    BIconCheckAll,
    BIconCheckCircle,
    BIconCheckCircleFill,
    BIconCheckSquare,
    BIconCheckSquareFill,
    BIconChevronBarContract,
    BIconChevronBarDown,
    BIconChevronBarExpand,
    BIconChevronBarLeft,
    BIconChevronBarRight,
    BIconChevronBarUp,
    BIconChevronCompactDown,
    BIconChevronCompactLeft,
    BIconChevronCompactRight,
    BIconChevronCompactUp,
    BIconChevronContract,
    BIconChevronDoubleDown,
    BIconChevronDoubleLeft,
    BIconChevronDoubleRight,
    BIconChevronDoubleUp,
    BIconChevronDown,
    BIconChevronExpand,
    BIconChevronLeft,
    BIconChevronRight,
    BIconChevronUp,
    BIconCircle,
    BIconCircleFill,
    BIconCircleHalf,
    BIconCircleSquare,
    BIconClipboard,
    BIconClipboardCheck,
    BIconClipboardData,
    BIconClipboardMinus,
    BIconClipboardPlus,
    BIconClipboardX,
    BIconClock,
    BIconClockFill,
    BIconClockHistory,
    BIconCloud,
    BIconCloudArrowDown,
    BIconCloudArrowDownFill,
    BIconCloudArrowUp,
    BIconCloudArrowUpFill,
    BIconCloudCheck,
    BIconCloudCheckFill,
    BIconCloudDownload,
    BIconCloudDownloadFill,
    BIconCloudFill,
    BIconCloudMinus,
    BIconCloudMinusFill,
    BIconCloudPlus,
    BIconCloudPlusFill,
    BIconCloudSlash,
    BIconCloudSlashFill,
    BIconCloudUpload,
    BIconCloudUploadFill,
    BIconCode,
    BIconCodeSlash,
    BIconCodeSquare,
    BIconCollection,
    BIconCollectionFill,
    BIconCollectionPlay,
    BIconCollectionPlayFill,
    BIconColumns,
    BIconColumnsGap,
    BIconCommand,
    BIconCompass,
    BIconCompassFill,
    BIconCone,
    BIconConeStriped,
    BIconController,
    BIconCpu,
    BIconCpuFill,
    BIconCreditCard,
    BIconCreditCard2Back,
    BIconCreditCard2BackFill,
    BIconCreditCard2Front,
    BIconCreditCard2FrontFill,
    BIconCreditCardFill,
    BIconCrop,
    BIconCup,
    BIconCupFill,
    BIconCupStraw,
    BIconCursor,
    BIconCursorFill,
    BIconCursorText,
    BIconDash,
    BIconDashCircle,
    BIconDashCircleFill,
    BIconDashSquare,
    BIconDashSquareFill,
    BIconDiagram2,
    BIconDiagram2Fill,
    BIconDiagram3,
    BIconDiagram3Fill,
    BIconDiamond,
    BIconDiamondFill,
    BIconDiamondHalf,
    BIconDice1,
    BIconDice1Fill,
    BIconDice2,
    BIconDice2Fill,
    BIconDice3,
    BIconDice3Fill,
    BIconDice4,
    BIconDice4Fill,
    BIconDice5,
    BIconDice5Fill,
    BIconDice6,
    BIconDice6Fill,
    BIconDisc,
    BIconDiscFill,
    BIconDiscord,
    BIconDisplay,
    BIconDisplayFill,
    BIconDistributeHorizontal,
    BIconDistributeVertical,
    BIconDoorClosed,
    BIconDoorClosedFill,
    BIconDoorOpen,
    BIconDoorOpenFill,
    BIconDot,
    BIconDownload,
    BIconDroplet,
    BIconDropletFill,
    BIconDropletHalf,
    BIconEarbuds,
    BIconEasel,
    BIconEaselFill,
    BIconEgg,
    BIconEggFill,
    BIconEggFried,
    BIconEject,
    BIconEjectFill,
    BIconEmojiAngry,
    BIconEmojiAngryFill,
    BIconEmojiDizzy,
    BIconEmojiDizzyFill,
    BIconEmojiExpressionless,
    BIconEmojiExpressionlessFill,
    BIconEmojiFrown,
    BIconEmojiFrownFill,
    BIconEmojiHeartEyes,
    BIconEmojiHeartEyesFill,
    BIconEmojiLaughing,
    BIconEmojiLaughingFill,
    BIconEmojiNeutral,
    BIconEmojiNeutralFill,
    BIconEmojiSmile,
    BIconEmojiSmileFill,
    BIconEmojiSmileUpsideDown,
    BIconEmojiSmileUpsideDownFill,
    BIconEmojiSunglasses,
    BIconEmojiSunglassesFill,
    BIconEmojiWink,
    BIconEmojiWinkFill,
    BIconEnvelope,
    BIconEnvelopeFill,
    BIconEnvelopeOpen,
    BIconEnvelopeOpenFill,
    BIconExclamation,
    BIconExclamationCircle,
    BIconExclamationCircleFill,
    BIconExclamationDiamond,
    BIconExclamationDiamondFill,
    BIconExclamationOctagon,
    BIconExclamationOctagonFill,
    BIconExclamationSquare,
    BIconExclamationSquareFill,
    BIconExclamationTriangle,
    BIconExclamationTriangleFill,
    BIconExclude,
    BIconEye,
    BIconEyeFill,
    BIconEyeSlash,
    BIconEyeSlashFill,
    BIconEyeglasses,
    BIconFacebook,
    BIconFile,
    BIconFileArrowDown,
    BIconFileArrowDownFill,
    BIconFileArrowUp,
    BIconFileArrowUpFill,
    BIconFileBarGraph,
    BIconFileBarGraphFill,
    BIconFileBinary,
    BIconFileBinaryFill,
    BIconFileBreak,
    BIconFileBreakFill,
    BIconFileCheck,
    BIconFileCheckFill,
    BIconFileCode,
    BIconFileCodeFill,
    BIconFileDiff,
    BIconFileDiffFill,
    BIconFileEarmark,
    BIconFileEarmarkArrowDown,
    BIconFileEarmarkArrowDownFill,
    BIconFileEarmarkArrowUp,
    BIconFileEarmarkArrowUpFill,
    BIconFileEarmarkBarGraph,
    BIconFileEarmarkBarGraphFill,
    BIconFileEarmarkBinary,
    BIconFileEarmarkBinaryFill,
    BIconFileEarmarkBreak,
    BIconFileEarmarkBreakFill,
    BIconFileEarmarkCheck,
    BIconFileEarmarkCheckFill,
    BIconFileEarmarkCode,
    BIconFileEarmarkCodeFill,
    BIconFileEarmarkDiff,
    BIconFileEarmarkDiffFill,
    BIconFileEarmarkEasel,
    BIconFileEarmarkEaselFill,
    BIconFileEarmarkExcel,
    BIconFileEarmarkExcelFill,
    BIconFileEarmarkFill,
    BIconFileEarmarkFont,
    BIconFileEarmarkFontFill,
    BIconFileEarmarkImage,
    BIconFileEarmarkImageFill,
    BIconFileEarmarkLock,
    BIconFileEarmarkLock2,
    BIconFileEarmarkLock2Fill,
    BIconFileEarmarkLockFill,
    BIconFileEarmarkMedical,
    BIconFileEarmarkMedicalFill,
    BIconFileEarmarkMinus,
    BIconFileEarmarkMinusFill,
    BIconFileEarmarkMusic,
    BIconFileEarmarkMusicFill,
    BIconFileEarmarkPerson,
    BIconFileEarmarkPersonFill,
    BIconFileEarmarkPlay,
    BIconFileEarmarkPlayFill,
    BIconFileEarmarkPlus,
    BIconFileEarmarkPlusFill,
    BIconFileEarmarkPost,
    BIconFileEarmarkPostFill,
    BIconFileEarmarkPpt,
    BIconFileEarmarkPptFill,
    BIconFileEarmarkRichtext,
    BIconFileEarmarkRichtextFill,
    BIconFileEarmarkRuled,
    BIconFileEarmarkRuledFill,
    BIconFileEarmarkSlides,
    BIconFileEarmarkSlidesFill,
    BIconFileEarmarkSpreadsheet,
    BIconFileEarmarkSpreadsheetFill,
    BIconFileEarmarkText,
    BIconFileEarmarkTextFill,
    BIconFileEarmarkWord,
    BIconFileEarmarkWordFill,
    BIconFileEarmarkX,
    BIconFileEarmarkXFill,
    BIconFileEarmarkZip,
    BIconFileEarmarkZipFill,
    BIconFileEasel,
    BIconFileEaselFill,
    BIconFileExcel,
    BIconFileExcelFill,
    BIconFileFill,
    BIconFileFont,
    BIconFileFontFill,
    BIconFileImage,
    BIconFileImageFill,
    BIconFileLock,
    BIconFileLock2,
    BIconFileLock2Fill,
    BIconFileLockFill,
    BIconFileMedical,
    BIconFileMedicalFill,
    BIconFileMinus,
    BIconFileMinusFill,
    BIconFileMusic,
    BIconFileMusicFill,
    BIconFilePerson,
    BIconFilePersonFill,
    BIconFilePlay,
    BIconFilePlayFill,
    BIconFilePlus,
    BIconFilePlusFill,
    BIconFilePost,
    BIconFilePostFill,
    BIconFilePpt,
    BIconFilePptFill,
    BIconFileRichtext,
    BIconFileRichtextFill,
    BIconFileRuled,
    BIconFileRuledFill,
    BIconFileSlides,
    BIconFileSlidesFill,
    BIconFileSpreadsheet,
    BIconFileSpreadsheetFill,
    BIconFileText,
    BIconFileTextFill,
    BIconFileWord,
    BIconFileWordFill,
    BIconFileX,
    BIconFileXFill,
    BIconFileZip,
    BIconFileZipFill,
    BIconFiles,
    BIconFilesAlt,
    BIconFilm,
    BIconFilter,
    BIconFilterCircle,
    BIconFilterCircleFill,
    BIconFilterLeft,
    BIconFilterRight,
    BIconFilterSquare,
    BIconFilterSquareFill,
    BIconFlag,
    BIconFlagFill,
    BIconFlower1,
    BIconFlower2,
    BIconFlower3,
    BIconFolder,
    BIconFolder2,
    BIconFolder2Open,
    BIconFolderCheck,
    BIconFolderFill,
    BIconFolderMinus,
    BIconFolderPlus,
    BIconFolderSymlink,
    BIconFolderSymlinkFill,
    BIconFolderX,
    BIconFonts,
    BIconForward,
    BIconForwardFill,
    BIconFront,
    BIconFullscreen,
    BIconFullscreenExit,
    BIconFunnel,
    BIconFunnelFill,
    BIconGear,
    BIconGearFill,
    BIconGearWide,
    BIconGearWideConnected,
    BIconGem,
    BIconGeo,
    BIconGeoAlt,
    BIconGeoAltFill,
    BIconGeoFill,
    BIconGift,
    BIconGiftFill,
    BIconGithub,
    BIconGlobe,
    BIconGlobe2,
    BIconGoogle,
    BIconGraphDown,
    BIconGraphUp,
    BIconGrid,
    BIconGrid1x2,
    BIconGrid1x2Fill,
    BIconGrid3x2,
    BIconGrid3x2Gap,
    BIconGrid3x2GapFill,
    BIconGrid3x3,
    BIconGrid3x3Gap,
    BIconGrid3x3GapFill,
    BIconGridFill,
    BIconGripHorizontal,
    BIconGripVertical,
    BIconHammer,
    BIconHandIndex,
    BIconHandIndexThumb,
    BIconHandThumbsDown,
    BIconHandThumbsUp,
    BIconHandbag,
    BIconHandbagFill,
    BIconHash,
    BIconHdd,
    BIconHddFill,
    BIconHddNetwork,
    BIconHddNetworkFill,
    BIconHddRack,
    BIconHddRackFill,
    BIconHddStack,
    BIconHddStackFill,
    BIconHeadphones,
    BIconHeadset,
    BIconHeart,
    BIconHeartFill,
    BIconHeartHalf,
    BIconHeptagon,
    BIconHeptagonFill,
    BIconHeptagonHalf,
    BIconHexagon,
    BIconHexagonFill,
    BIconHexagonHalf,
    BIconHourglass,
    BIconHourglassBottom,
    BIconHourglassSplit,
    BIconHourglassTop,
    BIconHouse,
    BIconHouseDoor,
    BIconHouseDoorFill,
    BIconHouseFill,
    BIconHr,
    BIconImage,
    BIconImageAlt,
    BIconImageFill,
    BIconImages,
    BIconInbox,
    BIconInboxFill,
    BIconInboxes,
    BIconInboxesFill,
    BIconInfo,
    BIconInfoCircle,
    BIconInfoCircleFill,
    BIconInfoSquare,
    BIconInfoSquareFill,
    BIconInputCursor,
    BIconInputCursorText,
    BIconInstagram,
    BIconIntersect,
    BIconJournal,
    BIconJournalAlbum,
    BIconJournalArrowDown,
    BIconJournalArrowUp,
    BIconJournalBookmark,
    BIconJournalBookmarkFill,
    BIconJournalCheck,
    BIconJournalCode,
    BIconJournalMedical,
    BIconJournalMinus,
    BIconJournalPlus,
    BIconJournalRichtext,
    BIconJournalText,
    BIconJournalX,
    BIconJournals,
    BIconJoystick,
    BIconJustify,
    BIconJustifyLeft,
    BIconJustifyRight,
    BIconKanban,
    BIconKanbanFill,
    BIconKey,
    BIconKeyFill,
    BIconKeyboard,
    BIconKeyboardFill,
    BIconLadder,
    BIconLamp,
    BIconLampFill,
    BIconLaptop,
    BIconLaptopFill,
    BIconLayers,
    BIconLayersFill,
    BIconLayersHalf,
    BIconLayoutSidebar,
    BIconLayoutSidebarInset,
    BIconLayoutSidebarInsetReverse,
    BIconLayoutSidebarReverse,
    BIconLayoutSplit,
    BIconLayoutTextSidebar,
    BIconLayoutTextSidebarReverse,
    BIconLayoutTextWindow,
    BIconLayoutTextWindowReverse,
    BIconLayoutThreeColumns,
    BIconLayoutWtf,
    BIconLifePreserver,
    BIconLightning,
    BIconLightningFill,
    BIconLink,
    BIconLink45deg,
    BIconLinkedin,
    BIconList,
    BIconListCheck,
    BIconListNested,
    BIconListOl,
    BIconListStars,
    BIconListTask,
    BIconListUl,
    BIconLock,
    BIconLockFill,
    BIconMailbox,
    BIconMailbox2,
    BIconMap,
    BIconMapFill,
    BIconMarkdown,
    BIconMarkdownFill,
    BIconMenuApp,
    BIconMenuAppFill,
    BIconMenuButton,
    BIconMenuButtonFill,
    BIconMenuButtonWide,
    BIconMenuButtonWideFill,
    BIconMenuDown,
    BIconMenuUp,
    BIconMic,
    BIconMicFill,
    BIconMicMute,
    BIconMicMuteFill,
    BIconMinecart,
    BIconMinecartLoaded,
    BIconMoon,
    BIconMouse,
    BIconMouse2,
    BIconMouse3,
    BIconMusicNote,
    BIconMusicNoteBeamed,
    BIconMusicNoteList,
    BIconMusicPlayer,
    BIconMusicPlayerFill,
    BIconNewspaper,
    BIconNodeMinus,
    BIconNodeMinusFill,
    BIconNodePlus,
    BIconNodePlusFill,
    BIconNut,
    BIconNutFill,
    BIconOctagon,
    BIconOctagonFill,
    BIconOctagonHalf,
    BIconOption,
    BIconOutlet,
    BIconPaperclip,
    BIconParagraph,
    BIconPatchCheck,
    BIconPatchCheckFill,
    BIconPatchExclamation,
    BIconPatchExclamationFill,
    BIconPatchMinus,
    BIconPatchMinusFill,
    BIconPatchPlus,
    BIconPatchPlusFill,
    BIconPatchQuestion,
    BIconPatchQuestionFill,
    BIconPause,
    BIconPauseBtn,
    BIconPauseBtnFill,
    BIconPauseCircle,
    BIconPauseCircleFill,
    BIconPauseFill,
    BIconPeace,
    BIconPeaceFill,
    BIconPen,
    BIconPenFill,
    BIconPencil,
    BIconPencilFill,
    BIconPencilSquare,
    BIconPentagon,
    BIconPentagonFill,
    BIconPentagonHalf,
    BIconPeople,
    BIconPeopleFill,
    BIconPercent,
    BIconPerson,
    BIconPersonBadge,
    BIconPersonBadgeFill,
    BIconPersonBoundingBox,
    BIconPersonCheck,
    BIconPersonCheckFill,
    BIconPersonCircle,
    BIconPersonDash,
    BIconPersonDashFill,
    BIconPersonFill,
    BIconPersonLinesFill,
    BIconPersonPlus,
    BIconPersonPlusFill,
    BIconPersonSquare,
    BIconPersonX,
    BIconPersonXFill,
    BIconPhone,
    BIconPhoneFill,
    BIconPhoneLandscape,
    BIconPhoneLandscapeFill,
    BIconPhoneVibrate,
    BIconPieChart,
    BIconPieChartFill,
    BIconPip,
    BIconPipFill,
    BIconPlay,
    BIconPlayBtn,
    BIconPlayBtnFill,
    BIconPlayCircle,
    BIconPlayCircleFill,
    BIconPlayFill,
    BIconPlug,
    BIconPlugFill,
    BIconPlus,
    BIconPlusCircle,
    BIconPlusCircleFill,
    BIconPlusSquare,
    BIconPlusSquareFill,
    BIconPower,
    BIconPrinter,
    BIconPrinterFill,
    BIconPuzzle,
    BIconPuzzleFill,
    BIconQuestion,
    BIconQuestionCircle,
    BIconQuestionCircleFill,
    BIconQuestionDiamond,
    BIconQuestionDiamondFill,
    BIconQuestionOctagon,
    BIconQuestionOctagonFill,
    BIconQuestionSquare,
    BIconQuestionSquareFill,
    BIconReceipt,
    BIconReceiptCutoff,
    BIconReception0,
    BIconReception1,
    BIconReception2,
    BIconReception3,
    BIconReception4,
    BIconRecord,
    BIconRecord2,
    BIconRecord2Fill,
    BIconRecordBtn,
    BIconRecordBtnFill,
    BIconRecordCircle,
    BIconRecordCircleFill,
    BIconRecordFill,
    BIconReply,
    BIconReplyAll,
    BIconReplyAllFill,
    BIconReplyFill,
    BIconRss,
    BIconRssFill,
    BIconScissors,
    BIconScrewdriver,
    BIconSearch,
    BIconSegmentedNav,
    BIconServer,
    BIconShare,
    BIconShareFill,
    BIconShield,
    BIconShieldCheck,
    BIconShieldExclamation,
    BIconShieldFill,
    BIconShieldFillCheck,
    BIconShieldFillExclamation,
    BIconShieldFillMinus,
    BIconShieldFillPlus,
    BIconShieldFillX,
    BIconShieldLock,
    BIconShieldLockFill,
    BIconShieldMinus,
    BIconShieldPlus,
    BIconShieldShaded,
    BIconShieldSlash,
    BIconShieldSlashFill,
    BIconShieldX,
    BIconShift,
    BIconShiftFill,
    BIconShop,
    BIconShopWindow,
    BIconShuffle,
    BIconSignpost,
    BIconSignpost2,
    BIconSignpost2Fill,
    BIconSignpostFill,
    BIconSignpostSplit,
    BIconSignpostSplitFill,
    BIconSim,
    BIconSimFill,
    BIconSkipBackward,
    BIconSkipBackwardBtn,
    BIconSkipBackwardBtnFill,
    BIconSkipBackwardCircle,
    BIconSkipBackwardCircleFill,
    BIconSkipBackwardFill,
    BIconSkipEnd,
    BIconSkipEndBtn,
    BIconSkipEndBtnFill,
    BIconSkipEndCircle,
    BIconSkipEndCircleFill,
    BIconSkipEndFill,
    BIconSkipForward,
    BIconSkipForwardBtn,
    BIconSkipForwardBtnFill,
    BIconSkipForwardCircle,
    BIconSkipForwardCircleFill,
    BIconSkipForwardFill,
    BIconSkipStart,
    BIconSkipStartBtn,
    BIconSkipStartBtnFill,
    BIconSkipStartCircle,
    BIconSkipStartCircleFill,
    BIconSkipStartFill,
    BIconSlack,
    BIconSlash,
    BIconSlashCircle,
    BIconSlashCircleFill,
    BIconSlashSquare,
    BIconSlashSquareFill,
    BIconSliders,
    BIconSmartwatch,
    BIconSortAlphaDown,
    BIconSortAlphaDownAlt,
    BIconSortAlphaUp,
    BIconSortAlphaUpAlt,
    BIconSortDown,
    BIconSortDownAlt,
    BIconSortNumericDown,
    BIconSortNumericDownAlt,
    BIconSortNumericUp,
    BIconSortNumericUpAlt,
    BIconSortUp,
    BIconSortUpAlt,
    BIconSoundwave,
    BIconSpeaker,
    BIconSpeakerFill,
    BIconSpellcheck,
    BIconSquare,
    BIconSquareFill,
    BIconSquareHalf,
    BIconStar,
    BIconStarFill,
    BIconStarHalf,
    BIconStickies,
    BIconStickiesFill,
    BIconSticky,
    BIconStickyFill,
    BIconStop,
    BIconStopBtn,
    BIconStopBtnFill,
    BIconStopCircle,
    BIconStopCircleFill,
    BIconStopFill,
    BIconStoplights,
    BIconStoplightsFill,
    BIconStopwatch,
    BIconStopwatchFill,
    BIconSubtract,
    BIconSuitClub,
    BIconSuitClubFill,
    BIconSuitDiamond,
    BIconSuitDiamondFill,
    BIconSuitHeart,
    BIconSuitHeartFill,
    BIconSuitSpade,
    BIconSuitSpadeFill,
    BIconSun,
    BIconSunglasses,
    BIconTable,
    BIconTablet,
    BIconTabletFill,
    BIconTabletLandscape,
    BIconTabletLandscapeFill,
    BIconTag,
    BIconTagFill,
    BIconTags,
    BIconTagsFill,
    BIconTelephone,
    BIconTelephoneFill,
    BIconTelephoneForward,
    BIconTelephoneForwardFill,
    BIconTelephoneInbound,
    BIconTelephoneInboundFill,
    BIconTelephoneMinus,
    BIconTelephoneMinusFill,
    BIconTelephoneOutbound,
    BIconTelephoneOutboundFill,
    BIconTelephonePlus,
    BIconTelephonePlusFill,
    BIconTelephoneX,
    BIconTelephoneXFill,
    BIconTerminal,
    BIconTerminalFill,
    BIconTextCenter,
    BIconTextIndentLeft,
    BIconTextIndentRight,
    BIconTextLeft,
    BIconTextParagraph,
    BIconTextRight,
    BIconTextarea,
    BIconTextareaResize,
    BIconTextareaT,
    BIconThermometer,
    BIconThermometerHalf,
    BIconThreeDots,
    BIconThreeDotsVertical,
    BIconToggle2Off,
    BIconToggle2On,
    BIconToggleOff,
    BIconToggleOn,
    BIconToggles,
    BIconToggles2,
    BIconTools,
    BIconTrash,
    BIconTrash2,
    BIconTrash2Fill,
    BIconTrashFill,
    BIconTree,
    BIconTreeFill,
    BIconTriangle,
    BIconTriangleFill,
    BIconTriangleHalf,
    BIconTrophy,
    BIconTrophyFill,
    BIconTruck,
    BIconTruckFlatbed,
    BIconTv,
    BIconTvFill,
    BIconTwitch,
    BIconTwitter,
    BIconType,
    BIconTypeBold,
    BIconTypeH1,
    BIconTypeH2,
    BIconTypeH3,
    BIconTypeItalic,
    BIconTypeStrikethrough,
    BIconTypeUnderline,
    BIconUiChecks,
    BIconUiChecksGrid,
    BIconUiRadios,
    BIconUiRadiosGrid,
    BIconUnion,
    BIconUnlock,
    BIconUnlockFill,
    BIconUpc,
    BIconUpcScan,
    BIconUpload,
    BIconVectorPen,
    BIconViewList,
    BIconViewStacked,
    BIconVinyl,
    BIconVinylFill,
    BIconVoicemail,
    BIconVolumeDown,
    BIconVolumeDownFill,
    BIconVolumeMute,
    BIconVolumeMuteFill,
    BIconVolumeOff,
    BIconVolumeOffFill,
    BIconVolumeUp,
    BIconVolumeUpFill,
    BIconVr,
    BIconWallet,
    BIconWallet2,
    BIconWalletFill,
    BIconWatch,
    BIconWifi,
    BIconWifi1,
    BIconWifi2,
    BIconWifiOff,
    BIconWindow,
    BIconWrench,
    BIconX,
    BIconXCircle,
    BIconXCircleFill,
    BIconXDiamond,
    BIconXDiamondFill,
    BIconXOctagon,
    BIconXOctagonFill,
    BIconXSquare,
    BIconXSquareFill,
    BIconYoutube,
    BIconZoomIn,
    BIconZoomOut
  }
})

// Export the BootstrapVueIcons plugin installer
// Mainly for the stand-alone bootstrap-vue-icons.xxx.js builds
export const BootstrapVueIcons = /*#__PURE__*/ pluginFactoryNoConfig(
  { plugins: { IconsPlugin } },
  { NAME: 'BootstrapVueIcons' }
)

// --- END AUTO-GENERATED FILE ---
